import React, {
  useState,
  useCallback,
  useMemo,
  useEffect,
  useRef,
} from "react";
import ReactFlow, {
  // MiniMap,
  // Controls,
  Background,
  useNodesState,
  useEdgesState,
  BackgroundVariant,
  getNodesBounds,
} from "reactflow";
import "reactflow/dist/style.css";
// import PhoneInput from "react-phone-input-2";
// import SetRootHeadPopup from "../Popups/SetRootHeadPopup";
import AddMemberPopup from "../Popups/AddMemberPopup";
import AddFamilyMemberPopup from "../Popups/AddFamilyMemberPopup";
// import ImportDataPopup from "../Popups/ImportDataPopup";
import RootHeadModal from "../../Modals/RootHeadModal";
import AddMemberModal from "../../Modals/AddMemberModal";

// Family Tree Components
import FamilyMemberNode from "../FamilyTree/FamilyMemberNode";
import LabelNode from "../FamilyTree/LabelNode";
import {
  // generateSampleFamilyTree,
  convertToReactFlowData,
} from "../FamilyTree/familyTreeUtils";
import { getApi, postApi } from "../../Services/apiService";
import { toast } from "react-toastify";
import "../../App.css";
import ViewMemberModal from "../../Modals/ViewMemberModal";
import ImportDataModal from "../../Modals/ImportDataModal";
import InviteMemberModal from "../../Modals/InviteMemberModal";
import ImportErrorModal from "../../Modals/ImportErrorModal";
import ReorderMultipleBirthModal from "../../Modals/ReorderMultipleBirthModal";
import { getOrdinalSuffix } from "../../Utils/generation";
import { sortByKey } from "../../Utils/sortByKey";
import FamilyTreeListView from "./familyTreeListView";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  EDIT_MEMBER_PARAM,
  RETURN_TO_PARAM,
  getSafeReturnPath,
  isMemberRecordEditLink,
} from "../../Utils/memberRecordEditLink";
import { formatNameWithSuffix } from "../../Utils/name";
import { formatHeadOfLineMemberDisplayName } from "../../Utils/dashboardMemberDisplayName";
import {
  getFamilyTreeIdFromStorage,
  setFamilyTreeIdInLoggedInRole,
  clearFamilyTreeIdsFromStorage,
} from "../../Utils/headOfLineRole";
import {
  getFamilyTreeHeadLineRestriction,
  isTreeSideApiValue,
  TREE_SIDE_API_FATHER,
  TREE_SIDE_API_MOTHER,
} from "../../Utils/subscriptionAccess";
import { getImportTreeSideStateFromHeaderPreference } from "../../Utils/importTreeSideLock";
import FeatureNoticeModal, {
  FAMILY_TREE_MOBILE_NOTICE,
  MOBILE_MEDIA_QUERY,
  isMobileViewport,
} from "../Shared/FeatureNoticeModal";

function FamilyTree() {
  /**
   * The tree canvas is unusable on a phone, so warn on arrival no matter which
   * button brought the user here (sidebar, dashboard widget, photo viewer, …).
   */
  // A report's "edit this record" link only needs the edit form, which works on
  // a phone, so it skips the notice.
  const [showMobileNotice, setShowMobileNotice] = useState(
    () => isMobileViewport() && !isMemberRecordEditLink()
  );
  const [activeView, setActiveView] = useState("tree");
  const [sortOrder, setSortOrder] = useState("oldest");
  const [showRootPopup, setShowRootPopup] = useState(false);
  const [showAddMemberPopup, setShowAddMemberPopup] = useState(false);
  const [showAddFamilyPopup, setShowAddFamilyPopup] = useState(false);
  const [selectedHead, setSelectedHead] = useState("");
  const [showImportPopup, setShowImportPopup] = useState(false);
  /** API `tree_side` (`Mother Side` | `Father Side`); set from InviteMemberModal or ImportDataModal. */
  const [importTreeSide, setImportTreeSide] = useState("");
  /** When true, family-line dropdown is read-only (plan or header + existing tree for that side). */
  const [importTreeSideSelectionLocked, setImportTreeSideSelectionLocked] =
    useState(false);
  /** `"both"` | `"mother"` | `"father"` — hide non-preferred line when header fixes side. */
  const [importTreeSideVisibleSides, setImportTreeSideVisibleSides] =
    useState("both");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddMemberModalOpen, setIsAddMemberModalOpen] = useState(false);
  const [isViewMemberModalOpen, setIsViewMemberModalOpen] = useState(false);
  const [rootHeadData, setRootHeadData] = useState(null);
  const [familyData, setFamilyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedParentMember, setSelectedParentMember] = useState(null); // For adding child
  const [familyTreeId, setFamilyTreeId] = useState(null); // Store family tree ID
  const [editMode, setEditMode] = useState(false); // Track if modal is in edit mode
  const [editMemberData, setEditMemberData] = useState(null); // Store member data for editing
  const [viewMemberData, setViewMemberData] = useState(null); // Store member data for viewing
  const [treeKey, setTreeKey] = useState(Date.now()); // Force re-render key
  const [showInviteMemberModal, setShowInviteMemberModal] = useState(false);
  const [openProceedToImportModal, setOpenProceedToImportModal] =
    useState(false);
  const [selectedIdForImport, setSelectedIdForImport] = useState(null);
  const [familyTreeIdForImport, setFamilyTreeIdForImport] = useState(null);
  const [importErrorModalOpen, setImportErrorModalOpen] = useState(false);
  const [importErrorMessage, setImportErrorMessage] = useState(null);
  const [hideImportButton, setHideImportButton] = useState(false);
  const [topOfLineData, setTopOfLineData] = useState(null);
  const [treeChildrenColors, setTreeChildrenColors] = useState([]);
  const [memberUpdated, setMemberUpdated] = useState(false); // Track if member was updated in list view
  const [familyTreeData, setFamilyTreeData] = useState(null);
  /** Counts from GET `/family-tree-hierarchy-v2/:id` → `data.*` (same level as `tree`, `family_tree`). */
  const [treeLegendStats, setTreeLegendStats] = useState(null);
  const [showReorderModal, setShowReorderModal] = useState(false);
  const [reorderModalData, setReorderModalData] = useState(null);
  const [showMultipleBirthModal, setShowMultipleBirthModal] = useState(false);

  const [rfInstance, setRfInstance] = useState(null); // React Flow instance
  const [generationsList, setGenerationsList] = useState([]);
  const [selectedGeneration, setSelectedGeneration] = useState(null);
  const [familyLineColorList, setFamilyLineColorList] = useState([]);
  const [selectedFamilyLineColor, setSelectedFamilyLineColor] = useState(null);
  const [colorMappings, setColorMappings] = useState({});

  const [fullNamesList, setFullNamesList] = useState([]);
  const [searchedKeyword, setSearchedKeyword] = useState("");

  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState([]);

  const searchContainerRef = useRef(null);
  // const [headOflineName, setHeadOflineName] = useState('');
  // const [headOflineFullName,setHeadOflineFullName] = useState('');
  const [showGenMenu, setShowGenMenu] = useState(false);
  const [showFamilyLineMenu, setShowFamilyLineMenu] = useState(false);

  const [searchTimeout, setSearchTimeout] = useState(null);

  const genMenuRef = useRef(null);
  const familyLineMenuRef = useRef(null);

  const [localUser, setLocalUser] = useState({});

  //Get id for the tree view
  const [idForTreeView, setIdForTreeView] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  // Where the edit form returns to when it was opened from a report.
  const returnAfterEditRef = useRef("");

  // Add this to your state declarations
const [isTreeReady, setIsTreeReady] = useState(false);
  const [selectedAgeFilter, setSelectedAgeFilter] = useState(null); // 'youngest' or 'oldest'


  const storedUser = JSON.parse(localStorage.getItem("userDetail"));

    // Track if we're transitioning between modals (don't clear parent in this case)
    // const isTransitioningRef = useRef(false);
  
    // ✅ Track if fetch is in progress to prevent duplicate calls
    const isFetchingRef = useRef(false);
  

  // Add this CSS in your styles
  const searchDropdownStyle = {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    backgroundColor: "white",
    border: "1px solid #ddd",
    borderRadius: "4px",
    maxHeight: "300px",
    overflowY: "auto",
    zIndex: 9999, // Increase z-index dramatically
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  };

  const userItemStyle = {
    padding: "10px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
  };

  const userImageStyle = {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    marginRight: "10px",
    objectFit: "cover",
  };

  // Track if we're transitioning between modals (don't clear parent in this case)
  const isTransitioningRef = useRef(false);

  // React Flow state
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);

  /**
   * Fit tree to the canvas so horizontal space is used fully when the default
   * fit would be limited by height (tall trees → huge left/right margins).
   * Uses width-based zoom in that case; user can pan vertically to see the rest.
   */
  const fitViewMaximizeHorizontal = useCallback((instance, options = {}) => {
    if (!instance) return;
    const {
      padding = 0.06,
      duration = 500,
      minZoom = 0.02,
      maxZoom = 1.5,
      topPadding = 48,
    } = options;

    const run = () => {
      const nodes = instance.getNodes().filter((n) => !n.hidden);
      if (nodes.length === 0) {
        instance.fitView({
          padding,
          includeHiddenNodes: false,
          minZoom,
          maxZoom,
          duration,
        });
        return;
      }
      const bounds = getNodesBounds(nodes);
      if (!bounds.width || !bounds.height) {
        instance.fitView({
          padding,
          includeHiddenNodes: false,
          minZoom,
          maxZoom,
          duration,
        });
        return;
      }
      const pane =
        document.querySelector(".family-tree-canvas .react-flow") ||
        document.querySelector(".family-tree-canvas");
      const w = pane?.clientWidth ?? 800;
      const h = pane?.clientHeight ?? 600;
      const padFactor = 1 + padding;
      const xZoom = w / (bounds.width * padFactor);
      const yZoom = h / (bounds.height * padFactor);
      const cx = bounds.x + bounds.width / 2;
      const cy = bounds.y + bounds.height / 2;

      let zoom;
      let x;
      let y;
      if (xZoom > yZoom) {
        // Height would limit zoom → large side margins. Prefer filling width.
        zoom = Math.max(minZoom, Math.min(maxZoom, xZoom));
        x = w / 2 - cx * zoom;
        y = topPadding - bounds.y * zoom;
      } else {
        zoom = Math.max(minZoom, Math.min(maxZoom, Math.min(xZoom, yZoom)));
        x = w / 2 - cx * zoom;
        y = h / 2 - cy * zoom;
      }

      instance.setViewport({ x, y, zoom }, { duration });
    };

    if (typeof requestAnimationFrame !== "undefined") {
      requestAnimationFrame(() => run());
    } else {
      setTimeout(run, 10);
    }
  }, []);

  /**
   * Initial tree view: floor zoom so labels + nearby nodes stay reader-sized (~0.55+).
   * Anchors top-left so the Gen / Start labels column stays in view; pan for the rest.
   */
  const fitViewReadableInitial = useCallback((instance, options = {}) => {
    if (!instance) return;

    const {
      // ~0.5–0.6 matches a “readable row” view (Gen labels + first nodes like design screenshots).
      readableMinZoom = 0.56,
      maxZoom = 1.5,
      padding = 0.03,
      leftPadding = 36,
      /** Extra horizontal nudge (screen px): shifts the graph right so left column labels aren’t clipped. */
      viewShiftRight = 52,
      topPadding = 48,
      duration = 400,
    } = options;

    const run = () => {
      const visibleNodes = instance.getNodes().filter((n) => !n.hidden);
      if (visibleNodes.length === 0) {
        instance.fitView({
          padding,
          includeHiddenNodes: false,
          minZoom: readableMinZoom,
          maxZoom,
          duration,
        });
        return;
      }

      const bounds = getNodesBounds(visibleNodes);
      if (!bounds.width || !bounds.height) {
        instance.fitView({
          padding,
          includeHiddenNodes: false,
          minZoom: readableMinZoom,
          maxZoom,
          duration,
        });
        return;
      }

      const pane =
        document.querySelector(".family-tree-canvas .react-flow") ||
        document.querySelector(".family-tree-canvas");
      const w = pane?.clientWidth ?? 800;
      const h = pane?.clientHeight ?? 600;
      const padFactor = 1 + padding * 2;
      // Fit horizontal extent first so generation labels + tree stay legible; pan vertically for depth.
      const zoomFitWidth = w / (bounds.width * padFactor);
      const zoomFitHeight = h / (bounds.height * padFactor);
      const zoomFitAll = Math.min(zoomFitWidth, zoomFitHeight);
      // When fitting everything would zoom out too far, prefer width-based zoom (usually larger).
      const naturalZoom =
        zoomFitAll < readableMinZoom
          ? Math.min(maxZoom, zoomFitWidth)
          : zoomFitAll;
      const zoom = Math.min(maxZoom, Math.max(readableMinZoom, naturalZoom));

      // Anchor top-left; viewShiftRight moves the whole scene slightly right so “Start/Top…” isn’t cut off.
      const x = leftPadding + viewShiftRight - bounds.x * zoom;
      const y = topPadding - bounds.y * zoom;

      instance.setViewport({ x, y, zoom }, { duration });
    };

    if (typeof requestAnimationFrame !== "undefined") {
      requestAnimationFrame(() => run());
    } else {
      setTimeout(run, 10);
    }
  }, []);

  const getTreePaneDimensions = useCallback(() => {
    const pane =
      document.querySelector(".family-tree-canvas .react-flow") ||
      document.querySelector(".family-tree-canvas");
    return {
      pane,
      width: pane?.clientWidth ?? 800,
      height: pane?.clientHeight ?? 600,
    };
  }, []);

  const getHorizontalPanLimits = useCallback(
    (instance) => {
      if (!instance) return null;
      const visibleNodes = instance.getNodes().filter((n) => !n.hidden);
      if (visibleNodes.length === 0) return null;
      const bounds = getNodesBounds(visibleNodes);
      if (!bounds.width) return null;
      const { width: w } = getTreePaneDimensions();
      const { zoom } = instance.getViewport();
      const leftPadding = 88;
      const rightPadding = 36;
      const maxX = leftPadding - bounds.x * zoom;
      const minX = w - rightPadding - (bounds.x + bounds.width) * zoom;
      return { minX, maxX };
    },
    [getTreePaneDimensions]
  );

  /**
   * Remembers the head-of-line we last jumped to, so repeated ‹ / › clicks keep
   * stepping one line at a time even when the viewport had to be clamped at the
   * tree edges (clamping means the head is no longer exactly under the centre).
   */
  const headOfLineNavRef = useRef(null);

  /** Horizontal centre of a node in flow coordinates (nodeOrigin is [0.5, 0]). */
  const getNodeCenterX = useCallback(
    (node) => node?.positionAbsolute?.x ?? node?.position?.x ?? 0,
    []
  );

  /** Visible heads of family lines (generation 2), left to right. */
  const getHeadOfLineNodes = useCallback(() => {
    if (!rfInstance) return [];
    return rfInstance
      .getNodes()
      .filter((n) => {
        if (n.hidden) return false;
        if (n.type && n.type !== "familyMember") return false;
        const generation = n.data?.generation_level ?? n.data?.generation;
        return Number(generation) === 2;
      })
      .sort((a, b) => getNodeCenterX(a) - getNodeCenterX(b));
  }, [rfInstance, getNodeCenterX]);

  /** Centres a head of line horizontally; only nudges vertically if it is off-screen. */
  const centerHeadOfLineNode = useCallback(
    (node, index, headCount) => {
      if (!rfInstance || !node) return;
      const { x, y, zoom } = rfInstance.getViewport();
      const { width, height } = getTreePaneDimensions();

      let targetX = width / 2 - getNodeCenterX(node) * zoom;
      const limits = getHorizontalPanLimits(rfInstance);
      if (limits) {
        const low = Math.min(limits.minX, limits.maxX);
        const high = Math.max(limits.minX, limits.maxX);
        targetX = Math.max(low, Math.min(high, targetX));
      }

      // Keep the vertical position untouched unless the row scrolled out of view.
      let targetY = y;
      const nodeTop = node.positionAbsolute?.y ?? node.position?.y ?? 0;
      const nodeHeight = node.height || node.data?.height || 120;
      const topOnScreen = y + nodeTop * zoom;
      const bottomOnScreen = y + (nodeTop + nodeHeight) * zoom;
      const topMargin = 72;
      if (topOnScreen < topMargin || bottomOnScreen > height - 24) {
        targetY = topMargin - nodeTop * zoom;
      }

      rfInstance.setViewport(
        { x: targetX, y: targetY, zoom },
        { duration: 400 }
      );
      headOfLineNavRef.current = { index, count: headCount, viewportX: targetX };
    },
    [rfInstance, getTreePaneDimensions, getHorizontalPanLimits, getNodeCenterX]
  );

  /**
   * « / » jump to the first / last head of family line, ‹ / › step to the
   * previous / next one and stop (with a notice) once there are no more.
   */
  const handleJumpToHeadOfLine = useCallback(
    (direction) => {
      if (!rfInstance) return;
      const heads = getHeadOfLineNodes();
      if (heads.length === 0) {
        return toast.info("No heads of family lines found");
      }

      const memo = headOfLineNavRef.current;
      const { x, zoom } = rfInstance.getViewport();
      const { width } = getTreePaneDimensions();
      const viewportCenterX = (width / 2 - x) / zoom;
      // Tolerance keeps a head that is already centred from counting as "next".
      const tolerance = 8 / (zoom || 1);
      const atRememberedHead =
        memo &&
        memo.count === heads.length &&
        memo.index >= 0 &&
        memo.index < heads.length &&
        Math.abs(memo.viewportX - x) <= 1;

      let targetIndex;
      if (direction === "far-left") {
        targetIndex = 0;
      } else if (direction === "far-right") {
        targetIndex = heads.length - 1;
      } else if (atRememberedHead) {
        targetIndex = memo.index + (direction === "left" ? -1 : 1);
      } else if (direction === "left") {
        targetIndex = -1;
        heads.forEach((node, i) => {
          if (getNodeCenterX(node) < viewportCenterX - tolerance) targetIndex = i;
        });
      } else {
        targetIndex = heads.findIndex(
          (node) => getNodeCenterX(node) > viewportCenterX + tolerance
        );
      }

      if (targetIndex < 0 || targetIndex >= heads.length) {
        return toast.info(
          direction === "left"
            ? "You're already at the first head of family line"
            : "You're already at the last head of family line"
        );
      }

      if (atRememberedHead && memo.index === targetIndex) {
        return toast.info(
          targetIndex === 0
            ? "You're already at the first head of family line"
            : "You're already at the last head of family line"
        );
      }

      centerHeadOfLineNode(heads[targetIndex], targetIndex, heads.length);
    },
    [
      rfInstance,
      getHeadOfLineNodes,
      getTreePaneDimensions,
      getNodeCenterX,
      centerHeadOfLineNode,
    ]
  );

  // universal focus helper: prefer fitView, fallback to setCenter
  const focusNodeById = useCallback(
    (nodeId, { padding = 0.25, duration = 800, zoom } = {}) => {
      if (!nodeId) return;
      const inst = rfInstance;
      if (!inst) {
        console.warn("React Flow instance not ready yet");
        return;
      }

      const node = inst.getNode(nodeId);
      if (!node) {
        console.warn("Node not found:", nodeId);
        return;
      }

      // If prefer fit & padding — this will center and zoom to node bounds
      try {
        inst.fitView({ nodes: [node], duration, padding });
        // If user passed an explicit zoom, also set it after a short timeout:
        if (typeof zoom === "number") {
          setTimeout(() => {
            inst.setCenter(
              node.position.x,
              node.position.y + (node.height || 0) / 2,
              { zoom, duration: 300 }
            );
          }, Math.min(duration, 900));
        }
      } catch (err) {
        // fallback: center manually (nodeOrigin [0.5, 0]: x is already horizontal center)
        inst.setCenter(
          node.position.x,
          node.position.y + (node.height || 0) / 2,
          { zoom: typeof zoom === "number" ? zoom : 1.2, duration: 500 }
        );
      }
    },
    [rfInstance]
  );

  const handleGoToHead = useCallback(() => {
    if (!nodes || nodes.length === 0) return;
    // find node flagged as head (see Step 5 on how to mark nodes)
    const headNode = nodes.find(
      (n) => n.data?.isHead || n.data?.generation == 1
    );
    if (!headNode) return toast.info("Head node not found");
    // optional: scroll page to the canvas first
    document
      .querySelector(".family-tree-canvas")
      ?.scrollIntoView({ behavior: "smooth", block: "center" });
    // then focus node
    focusNodeById(headNode.id, { padding: 0.2, duration: 800, zoom: 1.1 });
  }, [nodes, focusNodeById]);

  const handleGoToMe = useCallback(() => {
    if (!nodes || nodes.length === 0) return;
    
    // Get fresh user data from localStorage
    const currentUser = JSON.parse(localStorage.getItem("userDetail") || "{}");
    
    if (!currentUser || Object.keys(currentUser).length === 0) {
      return toast.info("User information not found");
    }
    
    // Try to find node by user_id first (most reliable)
    let meNode = null;
    if (currentUser.user_id || currentUser.id) {
      const userId = currentUser.user_id || currentUser.id;
      meNode = nodes.find((n) => n.data?.user_id == userId || n.data?.id == userId);
    }
    
    // Fallback to email matching if user_id didn't work
    if (!meNode && currentUser.email) {
      meNode = nodes.find((n) => 
        n.data?.email?.toLowerCase() === currentUser.email?.toLowerCase()
      );
    }
    
    // Fallback to name matching if email didn't work
    if (!meNode && currentUser.name) {
      meNode = nodes.find((n) => 
        n.data?.fullName?.toLowerCase() === currentUser.name?.toLowerCase()
      );
    }
    
    // Fallback to matching by first name + last name
    if (!meNode && currentUser.first_name && currentUser.last_name) {
      const fullName = `${currentUser.first_name} ${currentUser.last_name}`.toLowerCase().trim();
      meNode = nodes.find((n) => 
        n.data?.fullName?.toLowerCase() === fullName
      );
    }

    if (!meNode) {
      return toast.info("Your node not found");
    }
    
    document
      .querySelector(".family-tree-canvas")
      ?.scrollIntoView({ behavior: "smooth", block: "center" });
    focusNodeById(meNode.id, { padding: 0.2, duration: 800, zoom: 1.2 });
  }, [nodes, focusNodeById]);

  const handleGoToYoungest = useCallback(() => {
    if (!nodes || nodes.length === 0) return;
    
    // Set selected filter
    setSelectedAgeFilter('youngest');
    
    // Helper function to convert DOB to comparable timestamp
    const getDobTimestamp = (dob) => {
      if (!dob) return null;
      
      // If it's already a number (timestamp), return it
      if (typeof dob === 'number') {
        return dob;
      }
      
      // If it's a string, try to parse it
      if (typeof dob === 'string') {
        const trimmed = dob.trim();
        // Check if it's a numeric string (timestamp)
        if (/^-?\d+$/.test(trimmed)) {
          return parseInt(trimmed, 10);
        }
        // Try to parse as date
        const date = new Date(trimmed);
        if (!isNaN(date.getTime())) {
          return date.getTime();
        }
      }
      
      return null;
    };
    
    // Filter nodes that have DOB and are main members (not labels)
    const nodesWithDob = nodes
      .filter((n) => {
        if (n.type !== 'familyMember' || !n.data?.dob) return false;
        const generationLevel = n.data?.generation_level ?? n.data?.generation;
        return generationLevel !== 1; // exclude the Top of the Line
      })
      .map((n) => ({
        node: n,
        dobTimestamp: getDobTimestamp(n.data.dob)
      }))
      .filter((item) => item.dobTimestamp !== null);
    
    if (nodesWithDob.length === 0) {
      setSelectedAgeFilter(null);
      return toast.info("No members with date of birth found");
    }
    
    // Find the node with the latest (most recent) DOB (youngest)
    const youngest = nodesWithDob.reduce((max, current) => 
      current.dobTimestamp > max.dobTimestamp ? current : max
    );
    
    // Ensure filters remain visible when scrolling
    const headerElement = document.querySelector(".family-tree-header-cs");
    const topControlsElement = document.querySelector(".family-tree-top");
    const headerHeight = headerElement?.offsetHeight || 0;
    const topControlsHeight = topControlsElement?.offsetHeight || 0;
    const totalHeaderHeight = headerHeight + topControlsHeight;
    
    // Store current scroll position before focusing
    const scrollBeforeFocus = window.pageYOffset || document.documentElement.scrollTop;
    
    // Focus on the node
    focusNodeById(youngest.node.id, { padding: 0.2, duration: 800, zoom: 1.2 });
    
    // After a short delay, ensure filters are still visible
    setTimeout(() => {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      const headerTop = headerElement?.getBoundingClientRect().top || 0;
      
      // If header is scrolled out of view (above viewport), scroll back to show it
      if (headerTop < 0) {
        window.scrollTo({
          top: scrollBeforeFocus - Math.abs(headerTop) - 10, // Keep some padding
          behavior: "smooth"
        });
      }
    }, 100);
  }, [nodes, focusNodeById]);

  const handleGoToOldest = useCallback(() => {
    if (!nodes || nodes.length === 0) return;
    
    // Set selected filter
    setSelectedAgeFilter('oldest');
    
    // Helper function to convert DOB to comparable timestamp
    const getDobTimestamp = (dob) => {
      if (!dob) return null;
      
      // If it's already a number (timestamp), return it
      if (typeof dob === 'number') {
        return dob;
      }
      
      // If it's a string, try to parse it
      if (typeof dob === 'string') {
        const trimmed = dob.trim();
        // Check if it's a numeric string (timestamp)
        if (/^-?\d+$/.test(trimmed)) {
          return parseInt(trimmed, 10);
        }
        // Try to parse as date
        const date = new Date(trimmed);
        if (!isNaN(date.getTime())) {
          return date.getTime();
        }
      }
      
      return null;
    };
    
    // Filter nodes that have DOB and are main members (not labels)
    // Exclude generation 1 (Top of the Line/Start of the Line) members
    const nodesWithDob = nodes
      .filter((n) => {
        // Must be a family member with DOB
        if (n.type !== 'familyMember' || !n.data?.dob) return false;
        
        // Exclude generation 1 (Top of the Line) members
        const generation = n.data?.generation_level || n.data?.generation;
        const isHead = n.data?.isHead || false;
        
        // Skip if it's generation 1 or marked as head
        if (generation === 1 || isHead) return false;
        
        return true;
      })
      .map((n) => ({
        node: n,
        dobTimestamp: getDobTimestamp(n.data.dob)
      }))
      .filter((item) => item.dobTimestamp !== null);
    
    if (nodesWithDob.length === 0) {
      setSelectedAgeFilter(null);
      return toast.info("No members with date of birth found (excluding Top of the Line)");
    }
    
    // Find the node with the earliest (oldest) DOB among non-generation-1 members
    const oldest = nodesWithDob.reduce((min, current) => 
      current.dobTimestamp < min.dobTimestamp ? current : min
    );
    
    // Ensure filters remain visible when scrolling
    const headerElement = document.querySelector(".family-tree-header-cs");
    const topControlsElement = document.querySelector(".family-tree-top");
    const headerHeight = headerElement?.offsetHeight || 0;
    const topControlsHeight = topControlsElement?.offsetHeight || 0;
    const totalHeaderHeight = headerHeight + topControlsHeight;
    
    // Store current scroll position before focusing
    const scrollBeforeFocus = window.pageYOffset || document.documentElement.scrollTop;
    
    // Focus on the node
    focusNodeById(oldest.node.id, { padding: 0.2, duration: 800, zoom: 1.2 });
    
    // After a short delay, ensure filters are still visible
    setTimeout(() => {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      const headerTop = headerElement?.getBoundingClientRect().top || 0;
      
      // If header is scrolled out of view (above viewport), scroll back to show it
      if (headerTop < 0) {
        window.scrollTo({
          top: scrollBeforeFocus - Math.abs(headerTop) - 10, // Keep some padding
          behavior: "smooth"
        });
      }
    }, 100);
  }, [nodes, focusNodeById]);

  const handleGoToGeneration = useCallback(
    (generation) => {
      if (!rfInstance || !nodes || nodes.length === 0) return;

      // Find all nodes of the selected generation
      const generationNodes = nodes.filter(
        (node) => node.data?.generation_level === generation
      );

      if (generationNodes.length === 0) {
        return toast.info(`No nodes found for generation ${generation}`);
      }

      // Find the center node (or first node if even number)
      const centerIndex = Math.floor(generationNodes.length / 2);
      const centerNode = generationNodes[centerIndex];

      // Focus on the center node with a nice zoom
      focusNodeById(centerNode.id, {
        padding: 0.5,
        duration: 800,
        zoom: 0.6,
      });
    },
    [rfInstance, nodes, focusNodeById]
  );

  // Update your select onChange to use this function
  // const handleGenerationChange = useCallback((e) => {
  //   const generation = e.target.value ? Number(e.target.value) : null;
  //   setSelectedGeneration(generation);
  //   if (generation !== null) {
  //     handleGoToGeneration(generation);
  //   } else {
  //     // Optional: Reset view if "All Generations" is selected
  //     if (rfInstance) {
  //       rfInstance.fitView({ padding: 0.2, duration: 500 });
  //     }
  //   }
  // }, [handleGoToGeneration, rfInstance]);

  // const handleColorChange = useCallback((e) => {
  //   const colorName = e.target.value;
  //   const colorHex = colorMappings[colorName] || null;
  //   setSelectedFamilyLineColor(colorHex);

  //   if (colorHex) {
  //     // Find all nodes with this color
  //     const coloredNodes = nodes.filter(node =>
  //       node.data?.colorCode === colorHex ||
  //       node.data?.hex_code === colorHex
  //     );

  //     if (coloredNodes.length > 0) {
  //       // Find the center node
  //       const centerIndex = Math.floor(coloredNodes.length / 2);
  //       const centerNode = coloredNodes[centerIndex];

  //       // Focus on the center node
  //       focusNodeById(centerNode.id, {
  //         padding: 0.5,
  //         duration: 800,
  //         zoom: 0.6
  //       });
  //     } else {
  //       toast.info(`No nodes found with color ${colorName}`);
  //     }
  //   } else {
  //     // If "Family Color/Line" is selected, reset the view
  //     if (rfInstance) {
  //       rfInstance.fitView({ padding: 0.2, duration: 500 });
  //     }
  //   }
  // }, [nodes, rfInstance, focusNodeById, colorMappings]);

  const isNodeVisible = useCallback((node, genFilter, colorFilter) => {
    // If no filters are selected, show everything
    if (
      (!genFilter || genFilter === "") &&
      (!colorFilter || colorFilter === "")
    ) {
      return true;
    }

    const nodeGen = node.data?.generation_level;
    const nodeColor = node.data?.colorCode || node.data?.hex_code;

    // If only generation is selected
    if (genFilter && (!colorFilter || colorFilter === "")) {
      return Number(genFilter) === nodeGen;
    }

    // If only color is selected
    if (colorFilter && (!genFilter || genFilter === "")) {
      return colorFilter === nodeColor;
    }

    // If both filters are selected
    return Number(genFilter) === nodeGen && colorFilter === nodeColor;
  }, []);

  const handleColorChange = useCallback(
    (e) => {
      const colorName = e.target.value;
      const colorHex = colorMappings[colorName] || null;
      setSelectedFamilyLineColor(colorHex);

      if (colorHex) {
        // Find all nodes that match both filters
        const filteredNodes = nodes.filter((node) =>
          isNodeVisible(node, selectedGeneration, colorHex)
        );

        if (filteredNodes.length > 0) {
          // Focus on the first matching node
          focusNodeById(filteredNodes[0].id, {
            padding: 0.5,
            duration: 800,
            zoom: 0.6,
          });
        } else {
          toast.info(`No matching nodes found`);
        }
      } else {
        // Reset view if "Family Color/Line" is selected
        if (rfInstance) {
          fitViewReadableInitial(rfInstance, { duration: 500 });
        }
      }
    },
    [
      nodes,
      rfInstance,
      focusNodeById,
      colorMappings,
      selectedGeneration,
      isNodeVisible,
      fitViewReadableInitial,
    ]
  );

  const handleGenerationChange = useCallback(
    (e) => {
      const generation = e.target.value ? Number(e.target.value) : null;
      setSelectedGeneration(generation);

      if (generation !== null) {
        // Find all nodes that match both filters
        const filteredNodes = nodes.filter((node) =>
          isNodeVisible(node, generation, selectedFamilyLineColor)
        );

        if (filteredNodes.length > 0) {
          // Focus on the first matching node
          focusNodeById(filteredNodes[0].id, {
            padding: 0.5,
            duration: 1000,
            zoom: 0.5,
            // minZoom: 0.5,   // Then settle at this zoom level
            // maxZoom: 0.8    // Initial zoom level
          });
        } else {
          toast.info(`No matching nodes found for generation ${generation}`);
        }
      } else {
        // Reset view if "Generation" is selected
        if (rfInstance) {
          fitViewReadableInitial(rfInstance, { duration: 500 });
        }
      }
    },
    [nodes, rfInstance, focusNodeById, selectedFamilyLineColor, isNodeVisible, fitViewReadableInitial]
  );

  const handleSearchChange = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchedKeyword(searchValue);

    // Clear any existing timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // if (searchValue.length > 0) {
    //   const filtered = fullNamesList.filter(user =>
    //     user.name.toLowerCase().includes(searchValue)
    //   );
    //   const uniqueUsers = [...new Set(filtered)];
    //   setFilteredUsers(uniqueUsers);
    //   setShowSearchDropdown(uniqueUsers.length > 0);
    // } else {
    //   setShowSearchDropdown(false);
    // }

    // Set a new timeout
    const timeoutId = setTimeout(() => {
      if (searchValue.length > 0) {
        const filtered = fullNamesList.filter((user) =>
          user.name.toLowerCase().includes(searchValue)
        );
        // Use Set to remove duplicates by converting to string and back
        const uniqueUsers = Array.from(
          new Set(filtered.map(JSON.stringify))
        ).map(JSON.parse);
        // Sort the filtered users alphabetically by name
        const sortedUsers = sortByKey(uniqueUsers, 'name');
        setFilteredUsers(sortedUsers);
        setShowSearchDropdown(sortedUsers.length > 0);

      } else {
        setFilteredUsers([]);
        setShowSearchDropdown(false);
      }
    }, 300); // 300ms delay

    setSearchTimeout(timeoutId);
  };

  // Add this handler for clicking on a user
  const handleUserSelect = (userId) => {
    const node = nodes.find((n) => n.data.id == userId);
    const selectedUser = filteredUsers.find((user) => user.id == userId);
    if (node) {
      //set id for the tree view
      setIdForTreeView(userId);

      focusNodeById(node.id, {
        padding: 0.5,
        duration: 800,
        zoom: 0.6,
      });
    }
    setShowSearchDropdown(false);
    if (selectedUser) {
    setSearchedKeyword(selectedUser.name);
    }
  };

  // Combined function to extract both generations and colors
  const extractTreeMetadata = useCallback(async(treeData) => {

    
    const generationLevels = new Set();
    const colorNames = new Set();
    const colorMap = new Map(); // Store color name to hex code mapping
    const familyLineColorList = []; // Store objects with name, colorName, and hexCode for generation_level 2

    const traverseNodes = (nodes) => {
      nodes.forEach((node) => {

        // Extract generation level
        if (node.generation_level !== undefined && node.generation_level !== null) {
          generationLevels.add(node.generation_level);
        }

        // Extract color information
        const colorName = node.color_name || node.colorName || node.tree_color_name;
        const hexCode = node.hex_code || node.colorCode || node.tree_hex_code;

        if (colorName && colorName.trim() !== "") {
          colorNames.add(colorName);
          // Store hex code mapping
          if (hexCode && hexCode.trim() !== "") {
            colorMap.set(colorName, hexCode);
          }
        }

        // Search display: first + last + suffix/special (same as Heads of Line/Color page)
        const displayName =
          formatHeadOfLineMemberDisplayName(node) ||
          String(node.full_name || "").trim() ||
          `${node.first_name || ""} ${node.last_name || ""}`.trim();
        if (displayName) {
          fullNamesList.push({
            id: node.id || node._id,
            name: displayName,
            image: node.photo || node.image,
          });
        }

        // Extract first name for generation_level 2 dropdown
        // Take only the first word before space if there are spaces
        const firstName = node.first_name || "";
        const firstNameFirstWord = firstName.trim().split(' ')[0] || "";
        const suffix = node.suffix || "";
        const specialName = node.special_name || "";

        // When generation_level is 2, store first_name with suffix or special name (formatted) with color information
        if (node.generation_level === 2 && firstNameFirstWord && firstNameFirstWord.trim() !== "" && colorName && hexCode) {
          // Format name: if suffix exists, use "FirstName, Suffix."; if no suffix but special_name exists, use "FirstName SpecialName"; otherwise just "FirstName"
          let displayName = firstNameFirstWord;
          if (suffix) {
            // Format name with suffix (formatNameWithSuffix will add period if needed)
            displayName = formatNameWithSuffix(firstNameFirstWord, null, null, suffix);
          } else if (specialName) {
            // If no suffix but special name exists, format as "FirstName SpecialName" (no period, no comma)
            displayName = `${firstNameFirstWord} ${specialName}`;
          }
          
          // Check if this combination already exists to avoid duplicates
          const exists = familyLineColorList.some(
            (item) => item.hexCode === hexCode && item.name === displayName
          );

          if (!exists) {
            familyLineColorList.push({
              name: displayName,
              colorName: colorName,
              hexCode: hexCode,
            });
          }
        }

        if (node.children && node.children.length > 0) {
          traverseNodes(node.children);
        }
      });
    };

    if (treeData && treeData.length > 0) {
      traverseNodes(treeData);
    }

    // ✅ Update state ONCE after collecting all data
    setFullNamesList(fullNamesList);

    return {
      generations: Array.from(generationLevels).sort((a, b) => a - b),
      colors: Array.from(colorNames).sort(),
      colorMap: Object.fromEntries(colorMap),
      familyLineColorList: familyLineColorList, // Return the list with names and colors
    };
  }, []);

  // Extract all used colors from family tree data
  const allUsedColors = useMemo(() => {
    if (!familyTreeData || !Array.isArray(familyTreeData)) {
      return [];
    }

    const usedColorsSet = new Set();

    const extractColors = (nodes) => {
      nodes.forEach((node) => {
        // Extract color from node
        const hexCode = node.hex_code || node.colorCode || node.tree_hex_code;
        if (hexCode && hexCode.trim() !== '') {
          const normalizedColor = hexCode.trim().toLowerCase();
          usedColorsSet.add(normalizedColor);
        }

        // Recursively process children
        if (node.children && node.children.length > 0) {
          extractColors(node.children);
        }
      });
    };

    extractColors(familyTreeData);
    return Array.from(usedColorsSet);
  }, [familyTreeData]);

  // Multiple birth breakdown from tree nodes (for legend + modal)
  const multipleBirthBreakdown = useMemo(() => {
    if (!nodes || nodes.length === 0) return null;
    const twinSets = new Set();
    const tripletSets = new Set();
    const quadSets = new Set();
    const quinSets = new Set();
    const sexSets = new Set();
    const sepSets = new Set();
    const ocSets = new Set();
    const nunSets = new Set();
    nodes.forEach((node) => {
      if (node.type !== "familyMember") return;
      if (!node.data?.twinsTripletsType || !node.data?.twinsTripletsSetsCount) return;
      const setNumber = node.data.twinsTripletsSetsCount;
      const birthType = node.data.twinsTripletsType;
      const parentId = node.data.parentMemberId;
      // Set numbers restart under each parent; scope by parent so each branch's sets count separately.
      const setKey =
        parentId != null && parentId !== ""
          ? `${parentId}-${setNumber}-${birthType}`
          : `gen1-${setNumber}-${birthType}`;
      if (birthType === "twins") twinSets.add(setKey);
      else if (birthType === "triplets") tripletSets.add(setKey);
      else if (birthType === "quads") quadSets.add(setKey);
      else if (birthType === "quins") quinSets.add(setKey);
      else if (birthType === "sexs") sexSets.add(setKey);
      else if (birthType === "seps") sepSets.add(setKey);
      else if (birthType === "ocs") ocSets.add(setKey);
      else if (birthType === "nuns") nunSets.add(setKey);
    });
    const twins = twinSets.size;
    const triplets = tripletSets.size;
    const quads = quadSets.size;
    const quins = quinSets.size;
    const sexs = sexSets.size;
    const seps = sepSets.size;
    const ocs = ocSets.size;
    const nuns = nunSets.size;
    const total = twins + triplets + quads + quins + sexs + seps + ocs + nuns;
    if (total === 0) return null;
    return { twins, triplets, quads, quins, sexs, seps, ocs, nuns, total };
  }, [nodes]);

  const handleClearFilters = useCallback(() => {
    setSelectedGeneration(null);
    setSelectedFamilyLineColor(null);
    setSelectedAgeFilter(null);
    // Reset the React Flow view to initial state
    if (rfInstance) {
      fitViewReadableInitial(rfInstance, { duration: 800 });
    }
  }, [rfInstance, fitViewReadableInitial]);

  // Handle adding child to a member
  // FamilyTree.js - Fixed Logic
  const handleAddChild = useCallback(
    (memberData) => {


      const combinedData = {
        ...memberData,
        childrenColors: treeChildrenColors,
      };

      // 1. Set the Parent
      // setSelectedParentMember(memberData);
      setSelectedParentMember(combinedData);

      // 2. Pre-fill and set rootHeadData (THIS MUST COME FIRST)
      const parentGeneration = memberData.generation || 1;
      const inheritedRootHeadData = {
        headOfFamily:
          memberData.relation || (parentGeneration === 1 ? "Self" : "Grandfather - Root Head of Family"),
        selectedColor: memberData.colorCode || "#6366f1",
        selectedColorName: memberData.colorName || "Blue",
        generation: parentGeneration, // Explicitly pass generation
      };


      setRootHeadData(inheritedRootHeadData); // ✅ SET STATE FIRST

      // 3. Open the Modal (It will now receive the correct rootHeadData)
      
      setIsModalOpen(true); // ✅ OPEN MODAL LAST
    },
    [treeChildrenColors]
  );

  // Handle editing a member
  const handleEdit = useCallback(async (memberData) => {

    // Set edit mode and store member data
    setEditMode(true);
    const enhancedEditMemberData = {
      ...memberData,
      childrenColors: treeChildrenColors // Pass the same colors used for parentMember
    };


    // setEditMemberData(memberData);
    setEditMemberData(enhancedEditMemberData);

    // Pre-fill rootHeadData from member's data
    const inheritedRootHeadData = {
      headOfFamily: memberData.relation || (memberData.generation === 1 ? "Self" : "Grandfather - Root Head of Family"),
      selectedColor: memberData.colorCode || "#6366f1",
      selectedColorName: memberData.colorName || "Blue",
      colorName: memberData.colorName || "Blue",
      selectedHeadId: memberData.id,
    };

    setRootHeadData(inheritedRootHeadData);
    setIsAddMemberModalOpen(true);
  }, [treeChildrenColors]);

  // Handle view a member
  const handleView = useCallback(
    (memberData) => {


      // Set edit mode and store member data
      // setEditMode(true);
      const data = { ...topOfLineData, topOfLineData: topOfLineData };
      const combinedData = { ...memberData, data };
      setViewMemberData(combinedData);

      // Pre-fill rootHeadData from member's data
      const inheritedRootHeadData = {
        headOfFamily:
          memberData.relation || (memberData.generation === 1 ? "Self" : "Grandfather - Root Head of Family"),
        selectedColor: memberData.colorCode || "#6366f1",
        selectedColorName: memberData.colorName || "Blue",
        colorName: memberData.colorName || "Blue",
        selectedHeadId: memberData.id,
      };

      setRootHeadData(inheritedRootHeadData);
      setIsViewMemberModalOpen(true);
    },
    [topOfLineData]
  );

  // Helper function to recursively find all members in the tree
  const findAllMembers = useCallback((treeData, result = []) => {
    if (!treeData || !Array.isArray(treeData)) return result;
    
    treeData.forEach(member => {
      if (member) {
        result.push(member);
        if (member.children && member.children.length > 0) {
          findAllMembers(member.children, result);
        }
      }
    });
    
    return result;
  }, []);

  // Handle reorder multiple birth click
  const handleReorderMultipleBirth = useCallback((memberInfo) => {
    if (!familyTreeData || !memberInfo) return;

    // Find all members in the tree
    const allMembers = findAllMembers(familyTreeData);
    
    // DOB at start of day (ms) for ±3 day comparison (match badge logic)
    const getDobDayTs = (dob) => {
      if (dob == null || dob === '') return null;
      const d = typeof dob === 'number' ? new Date(dob) : new Date(String(dob).trim());
      if (!d || isNaN(d.getTime())) return null;
      return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    };
    const isDobWithinRange = (dob1, dob2, days = 3) => {
      const t1 = getDobDayTs(dob1);
      const t2 = getDobDayTs(dob2);
      if (t1 == null || t2 == null) return false;
      return Math.abs(t1 - t2) <= days * 24 * 60 * 60 * 1000;
    };

    // Find the clicked member
    const clickedMember = allMembers.find(m => 
      (m.id === memberInfo.memberId) || (m.user_id === memberInfo.userId)
    );

    if (!clickedMember) {
      toast.error("Member not found");
      return;
    }

    const clickedMemberDob = clickedMember.dob;
    if (!getDobDayTs(clickedMemberDob)) {
      toast.error("Member does not have a date of birth");
      return;
    }

    // Find all members with DOB within ±3 days (same multiple birth set as badge logic)
    const membersInSet = allMembers.filter(member =>
      isDobWithinRange(member.dob, clickedMemberDob, 3)
    );

    if (membersInSet.length < 2) {
      toast.error("No multiple birth set found");
      return;
    }

    // Open the modal with the members
    setReorderModalData({
      members: membersInSet,
      birthType: memberInfo.birthType,
      setNumber: memberInfo.setNumber,
    });
    setShowReorderModal(true);
  }, [familyTreeData, findAllMembers]);

  // User role: only admins (is_admin) can add/edit; regular users see add disabled with contact-admin message
  const canAddMembers = useMemo(() => {
    try {
      const role = JSON.parse(localStorage.getItem("loggedIn_user_role") || "{}");
      return role?.is_admin === true;
    } catch {
      return false;
    }
  }, [storedUser]);

  // Define custom node types with callback
  const nodeTypes = useMemo(
    () => ({
      familyMember: (props) => (
        <FamilyMemberNode
          {...props}
          onAddChild={handleAddChild}
          onEdit={handleEdit}
          onView={handleView}
          selectedGeneration={selectedGeneration}
          selectedFamilyLineColor={selectedFamilyLineColor}
          canAddMembers={canAddMembers}
        />
      ),
      label: (props) => <LabelNode {...props} />,
    }),
    [
      handleAddChild,
      handleEdit,
      handleView,
      selectedFamilyLineColor,
      selectedGeneration,
      canAddMembers,
    ]
  );

  //Update the local storage userDetail
  useEffect(() => {
    const updateLocalUser = () => {
      const storedUser = JSON.parse(localStorage.getItem("userDetail") || "{}");
      const treeId = getFamilyTreeIdFromStorage();
      const merged = {
        ...storedUser,
        ...(treeId ? { familyTreeId: treeId, family_tree_id: treeId } : {}),
      };
      if (merged && Object.keys(merged).length > 0) {
        setLocalUser(prevUser => {
          const prevString = JSON.stringify(prevUser);
          const storedString = JSON.stringify(merged);
          if (prevString !== storedString) {
            return merged;
          }
          return prevUser;
        });
      }
    };

    // Initial update on mount
    updateLocalUser();

    // Listen for storage changes (when localStorage is updated from other tabs/windows)
    const handleStorageChange = (e) => {
      if (e.key === "userDetail" || e.key === null) {
        updateLocalUser();
      }
    };

    // Listen for custom storage events (for same-tab updates)
    const handleCustomStorageChange = () => {
      updateLocalUser();
    };

    // Check localStorage when window regains focus (handles same-tab updates)
    const handleFocus = () => {
      updateLocalUser();
    };

    window.addEventListener("storage", handleStorageChange);
    // Custom event for same-tab localStorage updates
    window.addEventListener("localStorageChange", handleCustomStorageChange);
    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("localStorageChange", handleCustomStorageChange);
      window.removeEventListener("focus", handleFocus);
    };
  }, []); // Empty dependency array - only set up listeners once

  // Fetch family tree data from API
  const fetchFamilyTreeData = useCallback(async () => {
        // ✅ Prevent duplicate calls
        if (isFetchingRef.current) {
          // console.log("Fetch already in progress, skipping...");
          return;
        }
            // ✅ Set flag immediately to prevent duplicate calls
    isFetchingRef.current = true;
    setIsTreeReady(false);
    const family_tree_id = getFamilyTreeIdFromStorage();

    if (!family_tree_id) {
      console.error("family_tree_id missing");
      setLoading(false);
      setIsTreeReady(true);
      return;
    }

    try {
      let response;
      setLoading(true);

      console.log("running family tree heierarcgy api");

      if (sortOrder == "youngest") {
        response = await getApi(`/family-tree-hierarchy-v2/${family_tree_id}`, {
          params: { values: "young" },
        });
      } else if (sortOrder == "oldest") {
        response = await getApi(`/family-tree-hierarchy-v2/${family_tree_id}`, {
          params: { values: "old" },
        });
      } else {
        response = await getApi(`/family-tree-hierarchy-v2/${family_tree_id}`);
      }


      if (response?.statusCode == 404) {
        setHideImportButton(true);
      }

      // Check if response is successful and has data
      if (response?.statusCode === 200 && response?.data) {
        const apiData = response.data;



        // Extract the tree array from the nested structure
        const treeData = apiData.tree || [];
        const familyTreeInfo = apiData.family_tree || null;
        const ft = familyTreeInfo || {};
        setTreeLegendStats({
          grand_total:
            apiData.grand_total ??
            ft.grand_total ??
            apiData.total_members ??
            ft.total_members ??
            null,
          total_descendants:
            apiData.total_descendants ?? ft.total_descendants ?? null,
          total_in_laws: apiData.total_in_laws ?? ft.total_in_laws ?? null,
          total_multiple_birth_sets:
            apiData.total_multiple_birth_sets ??
            ft.total_multiple_birth_sets ??
            null,
          start_top_line:
            apiData.start_top_line ?? ft.start_top_line ?? null,
        });
        const topOfLine = apiData?.tree[0];
        const childrenColors = apiData?.tree[0]?.children?.map((data) => ({ colorCode: data?.hex_code, colorName: data?.color_name }));
        
        if (topOfLine?.generation_level == 1) {

          setTopOfLineData(topOfLine);
        }
        if (childrenColors) {
          setTreeChildrenColors(childrenColors);
        }
        setFamilyTreeData(treeData);




        //   // Extract generation levels
        // const generations = extractGenerationLevels(treeData);
        // setGenerationsList(generations);
        // console.log('Available generations:', generations);

        // Extract both generations and colors
        // const { generations, colors, colorMap, familyLineColorList: extractedFamilyLineColorList } = extractTreeMetadata(treeData);
        // // console.log("treedtsasstts", treeData)
        // setGenerationsList(generations);
        // const sortedColors = sortByKey(colors);

        // // Use the extracted familyLineColorList if available (for generation_level 2 with names)
        // // Otherwise fallback to sorted color names
        // if (extractedFamilyLineColorList && extractedFamilyLineColorList.length > 0) {
        //   // Sort the family line color list by name alphabetically
        //   const sortedFamilyLineColorList = sortByKey(extractedFamilyLineColorList, 'name');
        //   setFamilyLineColorList(sortedFamilyLineColorList);
        // } else {
        //   // Fallback to just color names if no generation_level 2 data found
        //   setFamilyLineColorList(sortedColors.map(colorName => ({
        //     name: colorName,
        //     colorName: colorName,
        //     hexCode: colorMap[colorName] || ""
        //   })));
        // }

        // setColorMappings(colorMap);





        // Extract and store family_tree_id
        const extractedFamilyTreeId = familyTreeInfo?.id || familyTreeInfo?.family_tree_id || null;
        setFamilyTreeId(extractedFamilyTreeId);

        if (extractedFamilyTreeId && !getFamilyTreeIdFromStorage()) {
          try {
            setFamilyTreeIdInLoggedInRole(extractedFamilyTreeId);
            console.log(
              "✅ Saved family tree id on loggedIn_user_role:",
              extractedFamilyTreeId
            );
          } catch (error) {
            console.error("Error persisting family tree id:", error);
          }
        }

        // Check if tree is empty
        if (!treeData || treeData.length === 0) {
          //No family members found - showing empty state
          setNodes([]);
          setEdges([]);
          setFamilyData([]);
          setTreeLegendStats(null);
          
          try {
            clearFamilyTreeIdsFromStorage();
            console.log("✅ Cleared family tree id from storage - tree is empty");
          } catch (error) {
            console.error("Error clearing family tree id from storage:", error);
          }
          
          return;
        }



        // Convert API data to React Flow format
        const { nodes: newNodes, edges: newEdges } = convertToReactFlowData(
          treeData,
          familyTreeInfo,
          sortOrder
        );

        // If conversion resulted in no nodes, show empty state
        if (newNodes.length === 0) {
          //No nodes generated - showing empty state
          setNodes([]);
          setEdges([]);
          setFamilyData([]);
          setTreeLegendStats(null);
          
          try {
            clearFamilyTreeIdsFromStorage();
            console.log("✅ Cleared family tree id from storage - no nodes generated");
          } catch (error) {
            console.error("Error clearing family tree id from storage:", error);
          }
          
          return;
        }

        // Data exists - display the tree
        // Root family name banner ("Name & Name Family") — omit from canvas (node id from familyTreeUtils)
        setNodes(newNodes.filter((n) => n.id !== "label-root-member"));
        // setEdges(newEdges);
        // ✅ Set edges after nodes are set (using setTimeout to ensure nodes render first)
        setFamilyData(treeData);
        setTreeKey(Date.now()); // Force re-render

        setTimeout(() => {
          setEdges(newEdges);
          setIsTreeReady(true);
          // Trigger fitView after edges are set
          setTimeout(() => {
            if (rfInstance) {
              fitViewReadableInitial(rfInstance, {
                duration: 400,
              });
            }
          }, 300);
        }, 1);

        console.log("running fetch family tree data")

        //extracting metadata for dropdowns and frontend search

        const { generations, colors, colorMap, familyLineColorList: extractedFamilyLineColorList } = await extractTreeMetadata(treeData);
        setGenerationsList(generations);
        const sortedColors = sortByKey(colors);

        if (extractedFamilyLineColorList && extractedFamilyLineColorList.length > 0) {
          setFamilyLineColorList(extractedFamilyLineColorList);
        } else {
          setFamilyLineColorList(sortedColors.map(colorName => ({
            name: colorName,
            colorName: colorName,
            hexCode: colorMap[colorName] || ""
          })));
        }

        setColorMappings(colorMap);



      } else {
        // API returned error or no data
        // API returned no data - showing empty state
        setNodes([]);
        setEdges([]);
        setFamilyData([]);
        setTreeLegendStats(null);
      }

      isFetchingRef.current = false; // ✅ Reset flag after successful fetch
    } catch (error) {
      console.error("Error fetching family tree:", error);
      toast.error("Failed to load family tree data");
      setNodes([]);
      setEdges([]);
      setFamilyData([]);
      setTreeLegendStats(null);
      // setIsTreeReady(false);
      
      setLoading(false); // Ensure loading is set to false on error
    } finally {
      setLoading(false); // Always set loading to false
      setIsTreeReady(true);
    //   setTimeout(()=>{
    //     setLoading(false); // Always set loading to false
    //     setIsTreeReady(true);
    //  },1000)
      
    }
  }, [setNodes, setEdges, sortOrder]);

  // Handle reorder modal close
  const handleReorderModalClose = useCallback((success) => {
    setShowReorderModal(false);
    setReorderModalData(null);
    
    if (success) {
      // Refresh the tree data
      fetchFamilyTreeData();
      setTreeKey(Date.now()); // Force re-render
    }
  }, [fetchFamilyTreeData]);

  // Fetch family tree data when tree id is available (from role / storage) or sort changes
  useEffect(() => {

    const family_tree_id = getFamilyTreeIdFromStorage();

    if (family_tree_id) {

      fetchFamilyTreeData();
    } else {
      // If no family_tree_id, stop loading
      console.warn("No family_tree_id found, stopping loading");
      setLoading(false);
    }
  }, [localUser?.familyTreeId, localUser?.family_tree_id, sortOrder]);

  useEffect(() => {
    return () => {
      // Clean up when component unmounts
      setNodes([]);
      setEdges([]);
      setIsTreeReady(false);
      isFetchingRef.current = false;
    };
  }, []);


  const handleImportedData = async (data) => {
    const treeSideForRequest = importTreeSide;
    try {

      setShowImportPopup(false);

      const formData = new FormData();
      formData.append("csv_file", data, data.name || "upload.csv");
      if (selectedIdForImport && familyTreeIdForImport) {
        formData.append("member_id", selectedIdForImport);
        formData.append("family_tree_id", familyTreeIdForImport);
      }
      if (isTreeSideApiValue(treeSideForRequest)) {
        formData.append("tree_side", treeSideForRequest);
      }

      const payload = {
        csv_file: formData,
      };
      const response = await postApi("/import-members-data", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setOpenProceedToImportModal(false);

      if (response?.status == 200 || response?.statusCode == 200) {
        // Set family_tree_id in localStorage from the import API response
        const familyTreeIdFromResponse = response?.data?.family_tree_id;
        if (familyTreeIdFromResponse && !getFamilyTreeIdFromStorage()) {
          try {
            setFamilyTreeIdInLoggedInRole(familyTreeIdFromResponse);
            console.log(
              "✅ Saved family tree id from import on loggedIn_user_role:",
              familyTreeIdFromResponse
            );
          } catch (error) {
            console.error("Error persisting family tree id from import:", error);
          }
        }
        
        toast.success("Data imported successfully");
        
        // Await fetchFamilyTreeData to ensure data is loaded and tree is refreshed
        await fetchFamilyTreeData();
      } else if (response?.message || response?.errors) {
        // Pass the full response object so the modal can access errors array
        setImportErrorMessage({
          message: response?.message || 'Import failed',
          errors: response?.errors || response?.error?.errors || [],
          error: response?.error || {}
        });
        setImportErrorModalOpen(true);
        // toast.error("The following emails already exist in this family tree. Please use different emails or remove them from CSV");
      } else {
        toast.error("Failed to import data");
      }
    } catch (error) {
      console.log(error);
      // Handle error response from API
      const errorResponse = error?.response?.data || error?.data || {};
      if (errorResponse?.message || errorResponse?.errors) {
        setImportErrorMessage({
          message: errorResponse?.message || 'Import failed',
          errors: errorResponse?.errors || errorResponse?.error?.errors || [],
          error: errorResponse?.error || {}
        });
        setImportErrorModalOpen(true);
      } else {
        toast.error("Failed to import data");
      }
    } finally {
      setImportTreeSide("");
      setImportTreeSideSelectionLocked(false);
      setImportTreeSideVisibleSides("both");
    }
  };

  const handleProceedToImport = async (data) => {
    try {
      if (data == null || data === "") {
        const r = getFamilyTreeHeadLineRestriction();
        if (r === "mother_only") setImportTreeSide(TREE_SIDE_API_MOTHER);
        else if (r === "father_only") setImportTreeSide(TREE_SIDE_API_FATHER);
        else setImportTreeSide("");
        setImportTreeSideSelectionLocked(false);
        setSelectedIdForImport(null);
        setFamilyTreeIdForImport(null);
        setShowImportPopup(true);
        return;
      }
      if (typeof data === "object") {
        const r = getFamilyTreeHeadLineRestriction();
        const side =
          isTreeSideApiValue(data.tree_side)
            ? data.tree_side
            : data.tree_side === "mother"
              ? TREE_SIDE_API_MOTHER
              : data.tree_side === "father"
                ? TREE_SIDE_API_FATHER
                : r === "mother_only"
                  ? TREE_SIDE_API_MOTHER
                  : r === "father_only"
                    ? TREE_SIDE_API_FATHER
                    : "";
        setImportTreeSide(side);
        setImportTreeSideSelectionLocked(data.tree_side_selection_locked === true);
        setImportTreeSideVisibleSides(
          typeof data.tree_side_visible_sides === "string"
            ? data.tree_side_visible_sides
            : "both"
        );

        const hasMemberPick =
          data.selectedId != null && String(data.selectedId).trim() !== "";
        if (hasMemberPick) {
          setSelectedIdForImport(data.selectedId);
          setFamilyTreeIdForImport(data.familyTreeId ?? null);
          setTimeout(() => {
            setOpenProceedToImportModal(true);
          }, 300);
          return;
        }
        setSelectedIdForImport(null);
        setFamilyTreeIdForImport(null);
        setShowImportPopup(true);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  /**
   * Direct “Import Data” (no invite step): when plan is “both”, align with header `header_preferred_family_side` (no tree id required).
   */
  useEffect(() => {
    if (!showImportPopup) return;
    const r = getFamilyTreeHeadLineRestriction();
    if (r === "mother_only" || r === "father_only") {
      setImportTreeSideSelectionLocked(true);
      setImportTreeSideVisibleSides("both");
      return;
    }
    if (r !== "both") return;

    const { apiSide, locked, visibleSides } =
      getImportTreeSideStateFromHeaderPreference();
    if (locked && apiSide) {
      setImportTreeSide(apiSide);
      setImportTreeSideSelectionLocked(true);
      setImportTreeSideVisibleSides(visibleSides);
    } else {
      setImportTreeSideSelectionLocked(false);
      setImportTreeSideVisibleSides("both");
    }
  }, [showImportPopup]);

  // Load data on component mount
  // useEffect(() => {
  //   fetchFamilyTreeData();

  //   const handleClickOutside = (event) => {
  //     if (
  //       searchContainerRef.current &&
  //       !searchContainerRef.current.contains(event.target)
  //     ) {
  //       setShowSearchDropdown(false);
  //     }

  //     // Generation menu dropdown
  //     if (
  //       genMenuRef.current &&
  //       !genMenuRef.current.contains(event.target)
  //     ) {
  //       setShowGenMenu(false);
  //     }

  //     //family line menu dropdown
  //     if (
  //       familyLineMenuRef.current &&
  //       !familyLineMenuRef.current.contains(event.target)
  //     ) {
  //       setShowFamilyLineMenu(false);
  //     }
  //   };

  //   // Add when component mounts
  //   document.addEventListener("mousedown", handleClickOutside);

  //   // Clean up when component unmounts
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [fetchFamilyTreeData]);
  useEffect(() => {
    // fetchFamilyTreeData is now called in a separate useEffect when localUser is available

    const handleClickOutside = (event) => {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target)
      ) {
        setShowSearchDropdown(false);
      }

      // Generation menu dropdown
      if (
        genMenuRef.current &&
        !genMenuRef.current.contains(event.target)
      ) {
        setShowGenMenu(false);
      }

      //family line menu dropdown
      if (
        familyLineMenuRef.current &&
        !familyLineMenuRef.current.contains(event.target)
      ) {
        setShowFamilyLineMenu(false);
      }
    };

    // Use both mousedown and click for better detection
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("click", handleClickOutside);

    // Clean up when component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("click", handleClickOutside);
    };
  }, []); // Empty dependency array - only set up event listeners once

  // Handle focusing on a member from dashboard
  useEffect(() => {
    const memberId = searchParams.get('memberId');
    if (memberId && nodes.length > 0) {
      // Find the node with matching ID
      const targetNode = nodes.find((n) => n.data?.id == memberId);
      if (targetNode) {
        // Ensure we're on tree view
        if (activeView !== 'tree') {
          setActiveView('tree');
        }
        
        // Wait a bit for view switch, then scroll smoothly
        setTimeout(() => {
          const canvas = document.querySelector(".family-tree-canvas");
          if (canvas) {
            canvas.scrollIntoView({ 
              behavior: "smooth", 
              block: "center",
              inline: "center"
            });
          }
          
          // Wait for scroll to start, then focus on the node with smoother animation
          setTimeout(() => {
            focusNodeById(targetNode.id, {
              padding: 0.4,
              duration: 1200, // Longer duration for smoother transition
              zoom: 0.8, // Slightly closer zoom for better visibility
            });
            
            // Clear the URL parameter after focusing completes
            setTimeout(() => {
              setSearchParams({}, { replace: true });
            }, 1300);
          }, 300); // Small delay after scroll starts
        }, activeView !== 'tree' ? 200 : 100); // Longer delay if switching views
      }
    }
  }, [nodes, searchParams, focusNodeById, setSearchParams, activeView]);

  // Open a member's edit form straight away when a report linked here to fill in
  // their missing info; saving or closing the form goes back to the report.
  useEffect(() => {
    const memberId = searchParams.get(EDIT_MEMBER_PARAM);
    if (!memberId || nodes.length === 0) return;
    const returnTo = getSafeReturnPath(searchParams.get(RETURN_TO_PARAM));
    const targetNode = nodes.find(
      (n) => n.type === "familyMember" && String(n.data?.id) === String(memberId)
    );
    setSearchParams({}, { replace: true });
    if (!targetNode || !canAddMembers) {
      toast.error(
        !targetNode
          ? "That member's record could not be found."
          : "Only an admin can edit member records."
      );
      if (returnTo) navigate(returnTo);
      return;
    }
    returnAfterEditRef.current = returnTo;
    handleEdit(targetNode.data);
  }, [nodes, searchParams, setSearchParams, canAddMembers, handleEdit, navigate]);

  const returnToReportAfterEdit = useCallback(() => {
    const returnTo = returnAfterEditRef.current;
    if (!returnTo) return false;
    returnAfterEditRef.current = "";
    navigate(returnTo);
    return true;
  }, [navigate]);

  // Refit view when tree is ready to fill available space and align to top
  useEffect(() => {
    if (isTreeReady && rfInstance && nodes.length > 0 && edges.length > 0) {
      // Small delay to ensure DOM is fully rendered
      setTimeout(() => {
        fitViewReadableInitial(rfInstance, {
          duration: 400,
        });
      }, 200);
    }
  }, [isTreeReady, rfInstance, nodes.length, edges.length, fitViewReadableInitial]);

  // Center the family name label (root label) with respect to the start/top of line node — disabled while root label is filtered out at load
  // const LABEL_ROOT_ID = "label-root-member";
  // const LABEL_WIDTH = 2500;
  // const GEN1_NODE_WIDTH = 1000; // Gen 1 node min-width 720px but often renders wider with content
  // useEffect(() => {
  //   if (nodes.length === 0) return;
  //   const rootLabel = nodes.find((n) => n.id === LABEL_ROOT_ID);
  //   const gen1Node = nodes.find(
  //     (n) => n.type === "familyMember" && (n.data?.generation === 1 || n.data?.isRootHead)
  //   );
  //   if (!rootLabel || !gen1Node) return;
  //   const gen1X = gen1Node.position.x ?? 0;
  //   const gen1W = gen1Node.width ?? gen1Node.measured?.width ?? GEN1_NODE_WIDTH;
  //   const nodeCenterX = gen1X + gen1W / 2;
  //   const expectedLabelX = nodeCenterX - LABEL_WIDTH / 2;
  //   if (Math.abs((rootLabel.position?.x ?? 0) - expectedLabelX) > 2) {
  //     setNodes((prev) =>
  //       prev.map((n) =>
  //         n.id === LABEL_ROOT_ID
  //           ? { ...n, position: { ...n.position, x: expectedLabelX } }
  //           : n
  //       )
  //     );
  //   }
  // }, [nodes, setNodes]);

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_MEDIA_QUERY);
    // The tree opens fine once the window is desktop-sized, so drop the notice there
    const apply = () => {
      if (!mq.matches) setShowMobileNotice(false);
    };
    mq.addEventListener("change", apply);
    return () => mq.removeEventListener("change", apply);
  }, []);

  // Handle node click
  const onNodeClick = useCallback((event, node) => {
    
    // You can open a detail modal or edit form here
  }, []);

  return (
    <div className="family-tree-container family-head-rs">
      {showMobileNotice && (
        <FeatureNoticeModal
          title={FAMILY_TREE_MOBILE_NOTICE.title}
          message={FAMILY_TREE_MOBILE_NOTICE.message}
          onClose={() => setShowMobileNotice(false)}
        />
      )}
      {/* ===== TOP CONTROLS ===== */}
      {/* <div className="family-tree-top">
        <div className="left-controls">
          <div className="view-tabs" role="tablist" aria-label="View Tabs">
            <button
              className={activeView === "tree" ? "active" : ""}
              onClick={async () => {
                setActiveView("tree");
                // If member was updated, refresh tree data when switching to tree view
                if (memberUpdated) {

                  try {
                    await fetchFamilyTreeData();
                    setMemberUpdated(false); // Reset flag after refresh
                  } catch (error) {
                    console.error("Error refreshing tree data:", error);
                  }
                }
              }}
            >
              Tree View
            </button>
            <button
              className={activeView === "list" ? "active" : ""}
              onClick={() => setActiveView("list")}
            >
              List View
            </button>
          </div>
        </div>
      </div> */}


      <div className="family-tree-header-cs">
        <div className="inner-child-selection">
          {activeView === "tree" && (
            <>
              <div className="header-div">
                <button
                  className={`head-btn ${sortOrder === "oldest" ? "active" : ""}`}
                  onClick={() => setSortOrder("oldest")}
                >
                  Oldest to Youngest
                </button>
              </div>
              <div className="header-div">
                <button
                  className={`head-btn ${sortOrder === "youngest" ? "active" : ""}`}
                  onClick={() => setSortOrder("youngest")}
                >
                  Youngest to Oldest
                </button>
              </div>
              <div className="header-div">
                <button 
                  className={`head-btn ${selectedAgeFilter === "oldest" ? "active" : ""}`}
                  onClick={handleGoToOldest}
                >
                  Oldest Descendant
                </button>
              </div>
              <div className="header-div">
                <button 
                  className={`head-btn ${selectedAgeFilter === "youngest" ? "active" : ""}`}
                  onClick={handleGoToYoungest}
                >
                  Youngest Descendant
                </button>
              </div>
              <div className="header-div">
                <div className="dropdown-selection-cs family-color-line generation-dropdown" ref={genMenuRef}>
                  <div className="modal-dropdown-cs" onClick={() => setShowGenMenu(!showGenMenu)}>
                    {selectedGeneration
                      ? selectedGeneration + getOrdinalSuffix(selectedGeneration)
                      : "Generation"}
                  </div>
                  {
                    showGenMenu && (
                      <div
                        className="dropdown-cs"
                        role="listbox"
                        style={{ height: "maxMenuHeight", overflow: "auto" }}
                      >

                        <ul>
                          {generationsList?.map((generation) => (
                            <li
                              key={generation}
                              className={selectedGeneration === generation ? "active" : ""}
                              onClick={() => {
                                setSelectedGeneration(generation);
                                setShowGenMenu(false);
                                handleGenerationChange({ target: { value: generation } });
                              }}
                            >
                              {generation + getOrdinalSuffix(generation)}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )
                  }
                </div>
              </div>
              <div className="header-div">
                <div className="dropdown-selection-cs family-color-line" ref={familyLineMenuRef}>
                  <div className="modal-dropdown-cs" onClick={() => setShowFamilyLineMenu(!showFamilyLineMenu)}>
                    {/* Family Color/Line */}
                    {
                      // Show selected name with color dot OR placeholder
                      (() => {
                        const selectedItem = familyLineColorList.find(
                          (item) => (typeof item === 'object' ? item.hexCode : colorMappings[item]) === selectedFamilyLineColor
                        );
                        if (selectedItem && typeof selectedItem === 'object') {
                          return (
                            <div style={{ 
                              display: 'flex', 
                              flexDirection: 'column', 
                              alignItems: 'flex-start',
                              color: selectedItem.hexCode || '#000'
                            }}>
                              <span>{selectedItem.name} • {selectedItem.colorName}</span>
                              <span style={{ alignSelf: 'center' }}>Line</span>
                            </div>
                          );
                        } else if (selectedItem) {
                          const hexCode = colorMappings[selectedItem];
                          return hexCode ? (
                            <div style={{ 
                              display: 'flex', 
                              flexDirection: 'column', 
                              alignItems: 'flex-start',
                              color: hexCode
                            }}>
                              <span>{selectedItem} • {selectedItem}</span>
                              <span style={{ alignSelf: 'center' }}>Line</span>
                            </div>
                          ) : selectedItem;
                        }
                        const foundEntry = Object.entries(colorMappings).find(
                          ([name, hex]) => hex === selectedFamilyLineColor
                        );
                        if (foundEntry) {
                          const [colorName, hex] = foundEntry;
                          return (
                            <div style={{ 
                              display: 'flex', 
                              flexDirection: 'column', 
                              alignItems: 'flex-start',
                              color: hex
                            }}>
                              <span>{colorName}</span>
                              <span style={{ alignSelf: 'center' }}>Line</span>
                            </div>
                          );
                        }
                        return "Head of Line/Color";
                      })()
                    }
                  </div>
                  {
                    showFamilyLineMenu && (
                      <div
                        className="dropdown-cs"
                        role="listbox"
                        style={{ height: "maxMenuHeight", overflow: "auto" }}
                      >
                        <ul>
                          {familyLineColorList?.map((item, index) => {
                            // Handle both object format (with name) and string format (backward compatibility)
                            const isObject = typeof item === 'object';
                            const colorName = isObject ? item.colorName : item;
                            const displayName = isObject ? item.name : item;
                            const hexCode = isObject ? item.hexCode : colorMappings[item];
                            const key = isObject ? `${item.name}-${item.hexCode}-${index}` : `${item}-${index}`;

                            return (
                              <li
                                key={key}
                                className={
                                  hexCode === selectedFamilyLineColor
                                    ? "active"
                                    : ""
                                }
                                onClick={() => {
                                  // Convert selected colorName → its hex using colorMappings
                                  handleColorChange({ target: { value: colorName } });
                                  setShowFamilyLineMenu(false);
                                }}
                              >
                                {isObject ? (
                                  <span style={{ color: hexCode || '#000' }}>
                                    {displayName} • {colorName} Line
                                  </span>
                                ) : (
                                  <span style={{ color: hexCode || '#000' }}>
                                    {displayName} • {colorName} Line
                                  </span>
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    )
                  }
                </div>
              </div>
              <div className="header-div header-div-goto">
                <div className="right-controls snd-row">
                  <div className="goto-txt">Go to</div>
                  <div className="two-btn-set">
                    <button className="action-btn" onClick={handleGoToHead}>
                      Start/Top of the Line{" "}
                    </button>
                    <button className="action-btn-t" onClick={handleGoToMe}>
                      Me
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}



        </div>
        {activeView === "tree" && (
          <div className="family-tree-toolbar-search-row">
            <div className="header-div header-div-search">
              <div
                className="search-box"
                style={{ position: "relative" }}
                ref={searchContainerRef}
              >
                <input
                  type="text"
                  placeholder="Search..."
                  className="search-input"
                  value={searchedKeyword}
                  onChange={handleSearchChange}
                  onFocus={() => searchedKeyword && setShowSearchDropdown(true)}
                />
                {searchedKeyword && (
                  <span
                    onClick={() => {
                      setSearchedKeyword("");
                      setShowSearchDropdown(false);
                    }}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#555",
                      fontSize: "18px",
                      lineHeight: 1,
                      fontWeight: "bold",
                      zIndex: 10,
                      userSelect: "none",
                    }}
                  >
                    ×
                  </span>
                )}

                {showSearchDropdown && (
                  <div style={searchDropdownStyle}>
                    {filteredUsers.map((user, index) => (
                      <div
                        key={index}
                        style={userItemStyle}
                        onClick={() => handleUserSelect(user.id)}
                      >
                        <img
                          src={user.image || window.getPublicUrl("/assets/images/d-user.jpg")}
                          alt={user.name}
                          style={userImageStyle}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = window.getPublicUrl("/assets/images/d-user.jpg");
                          }}
                        />
                        <span>{user.name}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {!hideImportButton && canAddMembers && (
              <div className="header-div header-div-import">
                <div className="tree-family-import">
                  <button
                    className="add-btn"
                    onClick={() => setShowInviteMemberModal(true)}
                  >
                    + Import
                  </button>
                </div>
              </div>
            )}
            <div className="header-div header-div-clear-filters">
              <button className="add-btn clear-filters-btn" onClick={handleClearFilters}>
                Clear/Reset Filters
              </button>
            </div>
            <div className="header-div header-div-controls">
              <div className="right-controls snd-row">
                {rfInstance && (
                  <div className="custom-reactflow-controls tree-pan-controls">
                    <button
                      type="button"
                      className="auto-fit"
                      title="Jump to first head of family line"
                      aria-label="Jump to the first head of family line"
                      onClick={() => handleJumpToHeadOfLine("far-left")}
                    >
                      «
                    </button>
                    <button
                      type="button"
                      className="auto-fit"
                      title="Previous head of family line"
                      aria-label="Jump to the previous head of family line"
                      onClick={() => handleJumpToHeadOfLine("left")}
                    >
                      ‹
                    </button>
                    <button
                      type="button"
                      className="auto-fit"
                      title="Next head of family line"
                      aria-label="Jump to the next head of family line"
                      onClick={() => handleJumpToHeadOfLine("right")}
                    >
                      ›
                    </button>
                    <button
                      type="button"
                      className="auto-fit"
                      title="Jump to last head of family line"
                      aria-label="Jump to the last head of family line"
                      onClick={() => handleJumpToHeadOfLine("far-right")}
                    >
                      »
                    </button>
                  </div>
                )}
                {rfInstance && (
                  <div className="custom-reactflow-controls">
                    <button
                      type="button"
                      className="auto-fit"
                      title="Zoom in"
                      aria-label="Zoom in"
                      onClick={() => rfInstance.zoomIn()}
                    >
                      +
                    </button>
                    <button
                      type="button"
                      className="auto-fit"
                      title="Zoom out"
                      aria-label="Zoom out"
                      onClick={() => rfInstance.zoomOut()}
                    >
                      −
                    </button>
                    <button
                      type="button"
                      className="auto-fit"
                      title="Fit tree to view"
                      aria-label="Fit tree to view"
                      onClick={() => {
                        if (rfInstance) {
                          setTimeout(() => {
                            fitViewMaximizeHorizontal(rfInstance, {
                              padding: 0.06,
                              duration: 500,
                              minZoom: 0.02,
                              maxZoom: 1.5,
                              topPadding: 48,
                            });
                          }, 50);
                        }
                      }}
                    >
                      <div className="four-corner-icon">
                        <span className="tl"></span>
                        <span className="tr"></span>
                        <span className="bl"></span>
                        <span className="br"></span>
                      </div>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>


      {/* <div className="family-tree-top"> */}
      {/* <div className="right-controls"> */}
      {/* <div className="left-controls"> */}
      {/* <button
            className={`head-btn ${sortOrder === "oldest" ? "active" : ""}`}
            onClick={() => setSortOrder("oldest")}
          >
            Oldest to Youngest
          </button> */}
      {/* <button
            className={`head-btn ${sortOrder === "youngest" ? "active" : ""}`}
            onClick={() => setSortOrder("youngest")}
          >
            Youngest to Oldest
          </button> */}
      {/* </div> */}
      {/* <div className="tree-family-import">
            <button className="add-btn" onClick={handleClearFilters}>
              Clear/Reset Filters
            </button>
          </div> */}
      {/* <select
            className="dropdown"
            value={selectedGeneration || ""}
            onChange={handleGenerationChange}
          >
            <option>Generation</option>
            {generationsList?.map((generation) => {
              return (
                <option key={generation} value={generation}>
                  {generation + getOrdinalSuffix(generation)}
                </option>
              );
            })}
          </select> */}

      {/* <div className="dropdown-selection-cs family-color-line" ref={genMenuRef}>
            <div className="modal-dropdown-cs" onClick={() => setShowGenMenu(!showGenMenu)}>
              {selectedGeneration
                ? selectedGeneration + getOrdinalSuffix(selectedGeneration)
                : "Generation"}
            </div>
            {
              showGenMenu && (
                <div
                  className="dropdown-cs"
                  role="listbox"
                  style={{ height: "maxMenuHeight", overflow: "auto" }}
                >
                  
                  <ul>
                    {generationsList?.map((generation) => (
                      <li
                        key={generation}
                        className={selectedGeneration === generation ? "active" : ""}
                        onClick={() => {
                          setSelectedGeneration(generation);
                          setShowGenMenu(false);
                          handleGenerationChange({ target: { value: generation } });
                        }}
                      >
                        {generation + getOrdinalSuffix(generation)}
                      </li>
                    ))}
                  </ul>
                </div>
              )
            }
          </div> */}
      {/* <div className="dropdown-selection-cs family-color-line" ref={familyLineMenuRef}>
            <div className="modal-dropdown-cs" onClick={() => setShowFamilyLineMenu(!showFamilyLineMenu)}>
           
              {
                (() => {
                  const selectedItem = familyLineColorList.find(
                    (item) => (typeof item === 'object' ? item.hexCode : colorMappings[item]) === selectedFamilyLineColor
                  );
                  if (selectedItem && typeof selectedItem === 'object') {
                    return (
                      <span>
                        {selectedItem.name} (
                        <span
                          style={{
                            display: 'inline-block',
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: selectedItem.hexCode || '#000',
                            marginRight: '4px',
                            verticalAlign: 'middle'
                          }}
                        />
                        <span style={{ color: selectedItem.hexCode || '#000' }}>
                          {selectedItem.colorName}
                        </span>
                        )
                      </span>
                    );
                  } else if (selectedItem) {
                    const hexCode = colorMappings[selectedItem];
                    return hexCode ? (
                      <span>
                        <span
                          style={{
                            display: 'inline-block',
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: hexCode,
                            marginRight: '4px',
                            verticalAlign: 'middle'
                          }}
                        />
                        <span style={{ color: hexCode }}>
                          {selectedItem}
                        </span>
                      </span>
                    ) : selectedItem;
                  }
                  const foundEntry = Object.entries(colorMappings).find(
                    ([name, hex]) => hex === selectedFamilyLineColor
                  );
                  if (foundEntry) {
                    const [name, hex] = foundEntry;
                    return (
                      <span>
                        <span
                          style={{
                            display: 'inline-block',
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: hex,
                            marginRight: '4px',
                            verticalAlign: 'middle'
                          }}
                        />
                        <span style={{ color: hex }}>
                          {name}
                        </span>
                      </span>
                    );
                  }
                  return "Head of Line/Color";
                })()
              }
            </div>
            {
              showFamilyLineMenu && (
                <div
                  className="dropdown-cs"
                  role="listbox"
                  style={{ height: "maxMenuHeight", overflow: "auto" }}
                >
                  <ul>
                    {familyLineColorList?.map((item, index) => {
                      const isObject = typeof item === 'object';
                      const colorName = isObject ? item.colorName : item;
                      const displayName = isObject ? item.name : item;
                      const hexCode = isObject ? item.hexCode : colorMappings[item];
                      const key = isObject ? `${item.name}-${item.hexCode}-${index}` : `${item}-${index}`;
                      
                      return (
                        <li
                          key={key}
                          className={
                            hexCode === selectedFamilyLineColor
                              ? "active"
                              : ""
                          }
                          onClick={() => {
                            handleColorChange({ target: { value: colorName } });
                            setShowFamilyLineMenu(false);
                          }}
                        >
                          {isObject ? (
                            <span>
                              {displayName} (
                              <span
                                style={{
                                  display: 'inline-block',
                                  width: '8px',
                                  height: '8px',
                                  borderRadius: '50%',
                                  backgroundColor: hexCode || '#000',
                                  marginRight: '4px',
                                  verticalAlign: 'middle'
                                }}
                              />
                              <span style={{ color: hexCode || '#000' }}>
                                {colorName}
                              </span>
                              )
                            </span>
                          ) : (
                            <span>
                              <span
                                style={{
                                  display: 'inline-block',
                                  width: '8px',
                                  height: '8px',
                                  borderRadius: '50%',
                                  backgroundColor: hexCode || '#000',
                                  marginRight: '4px',
                                  verticalAlign: 'middle'
                                }}
                              />
                              <span style={{ color: hexCode || '#000' }}>
                                {colorName}
                              </span>
                            </span>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )
            }
          </div> */}

      {/* <select
            className="dropdown"

            value={
              Object.entries(colorMappings).find(
                ([name, hex]) => hex === selectedFamilyLineColor
              )?.[0] || ""
            }
            onChange={handleColorChange}
          >
            <option>Family Color/Line</option>
            
            {familyLineColorList?.map((color) => {
              return <option key={color}>{color}</option>;
            })}
          </select> */}

      {/* <div className="search-box">
            <input
              type="text"
              placeholder="Search..."
              className="search-input"
              onChange={handleSearchChange}
            />
            <i className="fas fa-search search-icon"></i>
          </div> */}

      {/* <div
            className="search-box"
            style={{ position: "relative" }}
            ref={searchContainerRef}
          >
            <input
              type="text"
              placeholder="Search..."
              className="search-input"
              value={searchedKeyword}
              onChange={handleSearchChange}
              onFocus={() => searchedKeyword && setShowSearchDropdown(true)}
            />
            <i className="fas fa-search search-icon"></i>

            {showSearchDropdown && (
              <div style={searchDropdownStyle}>
                {filteredUsers.map((user, index) => (
                  <div
                    key={index}
                    style={userItemStyle}
                    onClick={() => handleUserSelect(user.id)}
                  >
                    <img
                      src={user.image || "/assets/images/d-user.jpg"}
                      alt={user.name}
                      style={userImageStyle}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/assets/images/d-user.jpg";
                      }}
                    />
                    <span>{user.name}</span>
                  </div>
                ))}
              </div>
            )}
          </div> */}

      {/* <button className="add-btn" onClick={() => setShowAddFamilyPopup(true)}>+ Add</button> */}
      {/* <div className="tree-family-import">
            {hideImportButton ? (
              <></>
            ) : (
              <button
                className="add-btn"
                onClick={() => setShowInviteMemberModal(true)}
              >
                + Import
              </button>
            )}
          </div> */}
      {/* <div className="right-controls snd-row">
          <div className="goto-txt">Go to</div>
          <div className="two-btn-set">
            <button className="action-btn" onClick={handleGoToHead}>
              Start/Top of the Line{" "}
            </button>
            <button className="action-btn-t" onClick={handleGoToMe}>
              Me
            </button>
          </div>
        </div> */}
      {/* </div> */}
      {/* </div> */}

      {/* ===== SECOND ROW CONTROLS ===== */}
      <div className="family-tree-filters mb-0">
        {/* <div className="left-controls">
          <button
            className={`head-btn ${sortOrder === "oldest" ? "active" : ""}`}
            onClick={() => setSortOrder("oldest")}
          >
            Oldest to Youngest
          </button>
          <button
            className={`head-btn ${sortOrder === "youngest" ? "active" : ""}`}
            onClick={() => setSortOrder("youngest")}
          >
            Youngest to Oldest
          </button>
        </div> */}

        {/* <div className="right-controls snd-row">
          <div className="goto-txt">Go to</div>
          <div className="two-btn-set">
            <button className="action-btn" onClick={handleGoToHead}>
              Start/Top of the Line{" "}
            </button>
             <button className="action-btn" onClick={handleGoToHead}>Head of the Tree</button> 
            <button className="action-btn-t" onClick={handleGoToMe}>
              Me
            </button>
          </div>
        </div> */}
      </div>

      {/* ===== CONTENT AREA ===== */}
      <div className="content-area">
        {activeView === "tree" ? (
          <div className="tree-view">
            {loading  ? (
              <div className="tree-loading">
                <div className="tree-loading-spinner"></div>
                <p style={{ marginTop: "20px", color: "#6c757d" }}>
                  Loading family tree...
                </p>
              </div>
            ) : nodes.length === 0 ? (
              <div className="empty-state">
                <img
                  src={window.getPublicUrl("/assets/images/empty-data.png")}
                  alt="No data"
                  className="empty-img"
                />
                <p className="empty-text">
                  No family data found.
                  <br />
                  <span>
                    Start by adding the start/top of the line, which should be
                    the grandparents, then their children. Start assigning a
                    color to the grandparents and then a color for each of the
                    children (considered heads of their line).
                    <br />
                    <br />
                    If you fall under any one of the children of the
                    grandparents, then start adding your immediate family
                    data. Find out who's the point person for the heads of
                    the other lines (children of the grandparents) and send
                    them the data sheet to start filling in their immediate
                    family info. Ask them to name the file and return it by
                    email.
                  </span>
                </p>
                <div className="empty-buttons">
                  <button
                    className="blue-btn"
                    onClick={() => {
                      setSelectedParentMember(null);
                      setShowRootPopup(true);
                      setIsModalOpen(true);
                    }}
                  >
                    + Add First Generation
                  </button>
                  {canAddMembers && (
                    <button
                      className="outline-btn"
                      onClick={() => {
                        const r = getFamilyTreeHeadLineRestriction();
                        if (r === "mother_only") setImportTreeSide(TREE_SIDE_API_MOTHER);
                        else if (r === "father_only") setImportTreeSide(TREE_SIDE_API_FATHER);
                        else setImportTreeSide("");
                        setShowImportPopup(true);
                      }}
                    >
                      Import Data
                    </button>
                  )}
                </div>
              </div>
            ) : (
              <div className="family-tree-canvas">
                <ReactFlow
                  key={treeKey}
                  nodes={nodes}
                  edgeTypes={{
                    default: {
                      type: 'step', // Try: 'straight', 'step', 'smoothstep', 'bezier'
                    }
                  }}
                  edges={edges}
                  onNodesChange={onNodesChange}
                  onEdgesChange={onEdgesChange}
                  onNodeClick={onNodeClick}
                  nodeTypes={nodeTypes}
                  nodeOrigin={[0.5, 0]}
                  fitView={false}
                  fitViewOptions={{
                    padding: 0.05,
                    includeHiddenNodes: false,
                    minZoom: 0.04,
                    maxZoom: 1.5,
                  }}
                  attributionPosition="bottom-left"
                  minZoom={0.04}
                  maxZoom={1.5}
                  nodesDraggable={false}
                  nodesConnectable={false}
                  elementsSelectable={true}
                  panOnDrag={true}
                  zoomOnScroll={true}
                  zoomOnPinch={true}
                  panOnScroll={false}
                  onInit={(instance) => {
                    setRfInstance(instance);
                    // Fit view after instance is initialized
                    if (nodes.length > 0 && edges.length > 0) {
                        setTimeout(() => {
                          fitViewReadableInitial(instance, {
                            duration: 400,
                          });
                        }, 100);
                    }
                  }}
                  onlyRenderVisibleElements={true}
                >
                  <Background
                    variant={BackgroundVariant.Dots}
                    gap={16}
                    size={1}
                    color="#cbd5e0"
                  />
                  {/* <Controls /> */}
                  {/* <MiniMap 
                    nodeColor={(node) => node.data.colorCode || '#6366f1'}
                    maskColor="rgba(0, 0, 0, 0.1)"
                    style={{
                      backgroundColor: '#f8f9fa',
                    }}
                  /> */}
                </ReactFlow>
              </div>
            )}
          </div>
        ) : (
          <FamilyTreeListView
            family_tree_id={getFamilyTreeIdFromStorage()}
            idForTreeView={idForTreeView}
            searchedKeyword={searchedKeyword}
            handleSearchChange={handleSearchChange}
            showSearchDropdown={showSearchDropdown}
            setShowSearchDropdown={setShowSearchDropdown}
            filteredUsers={filteredUsers}
            handleUserSelect={handleUserSelect}
            searchContainerRef={searchContainerRef}
            searchDropdownStyle={searchDropdownStyle}
            userItemStyle={userItemStyle}
            userImageStyle={userImageStyle}
            onMemberUpdate={async () => {
              // Refresh tree data and set flag to refresh again when switching to tree view
              await fetchFamilyTreeData();
              setMemberUpdated(true); // Mark that member was updated
            }}
          />

        )}
      </div>

      {/* Legend for Family Tree - at the absolute bottom */}
      {activeView === "tree" && !loading && nodes.length > 0 && (() => {
        // Start/Top of line: still derived from rendered nodes (not in API payload).
        let totalDescendantsComputed = 0;
        let totalInLawsComputed = 0;
        let startTopOfLineCount = 0;
        nodes.forEach(node => {
          if (node.type === 'familyMember') {
            const generation =
              node.data?.generation_level ?? node.data?.generation;
            const isTopOfLine =
              generation === 1 || Boolean(node.data?.isHead);
            if (isTopOfLine) {
              // Gen 1 is one React Flow node but can show two people (primary + spouse) in the same card
              startTopOfLineCount += 1;
              const hasSpouseOnCard =
                node.data?.spouseFullName ||
                node.data?.spouseFirstName ||
                node.data?.spouse_first_name;
              if (hasSpouseOnCard) startTopOfLineCount += 1;
            } else {
              totalDescendantsComputed++;
            }
            if (node.data?.spouseFullName || node.data?.spouseFirstName) {
              totalInLawsComputed++;
            }
          }
        });
        const api = treeLegendStats;
        const totalDescendants =
          api?.total_descendants != null
            ? api.total_descendants
            : totalDescendantsComputed;
        const totalInLaws =
          api?.total_in_laws != null ? api.total_in_laws : totalInLawsComputed;
        const grandTotal =
          api?.grand_total != null
            ? api.grand_total
            : totalDescendants + totalInLaws;
        const startTopDisplay =
          api?.start_top_line != null
            ? api.start_top_line
            : startTopOfLineCount;
        const descendantLabel = 'Descendant(s)';
        const inLawLabel = 'In-Law(s)';
        const breakdown = multipleBirthBreakdown;
        const multipleBirthLegendCount =
          api?.total_multiple_birth_sets != null
            ? api.total_multiple_birth_sets
            : breakdown?.total ?? 0;
        const hasMultipleBirths = multipleBirthLegendCount > 0;
        const multipleBirthClickable = Boolean(breakdown?.total);
        return (
        <div className="family-tree-legend">
          <span className="family-tree-legend-label" style={{ 
            fontWeight: 'bold',
            marginRight: "0px",
            fontSize: "24px"
          }}>LEGEND</span>
          <div className="family-tree-legend-items" style={{ fontSize: "14px" }}>
            <span className="family-tree-legend-text">
                <span style={{ color: "#0000FF", fontWeight: "bold" }}>Blue</span> text - <span style={{ fontWeight: 900 }}>Male(s)</span>
            </span>
            <span style={{ margin: "0 12px" }}>|</span>
            <span className="family-tree-legend-text">
                <span style={{ color: "#FF0000", fontWeight: "bold" }}>Red</span> text - <span style={{ fontWeight: 900 }}>Female(s)</span>
            </span>
            <span style={{ margin: "0 12px" }}>|</span>
            <span className="family-tree-legend-text">
              <span style={{ display: "inline-block", width: "16px", height: "16px" }}>
                <img 
                  src={window.getPublicUrl("/assets/images/angel.png")} 
                  alt="deceased" 
                  style={{ width: "100%", height: "100%" }}
                />
              </span>
                <span> Angel - <span style={{ fontWeight: 900 }}>Deceased</span></span>
              </span>
              <span style={{ margin: "0 12px" }}>|</span>
            {hasMultipleBirths && (
              <>
                <span className="family-tree-legend-text">
                  <span style={{ fontWeight: "bold" }}>Multiple Birth Sets </span>
                  <span
                    role={multipleBirthClickable ? "button" : undefined}
                    tabIndex={multipleBirthClickable ? 0 : undefined}
                    onClick={() => multipleBirthClickable && setShowMultipleBirthModal(true)}
                    onKeyDown={(e) => {
                      if (!multipleBirthClickable) return;
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setShowMultipleBirthModal(true);
                      }
                    }}
                    style={{
                      fontWeight: 900,
                      fontSize: "16px",
                      cursor: multipleBirthClickable ? "pointer" : "default",
                    }}
                    title={multipleBirthClickable ? "Click to view breakdown" : undefined}
                  >
                    ({multipleBirthLegendCount})
                  </span>
                </span>
                <span style={{ margin: "0 12px" }}>|</span>
              </>
            )}
            <span className="family-tree-legend-text">
                <span style={{ fontWeight: "bold" }}>Start/Top of line</span> <span style={{ fontWeight: 900, fontSize: '16px' }}>({startTopDisplay})</span>
            </span>
            <span style={{ margin: "0 12px" }}>|</span>
            <span className="family-tree-legend-text">
                <span style={{ fontWeight: "bold" }}>Total {descendantLabel}</span> <span style={{ fontWeight: 900, fontSize: '16px' }}>({totalDescendants})</span>
            </span>
            <span style={{ margin: "0 12px" }}>|</span>
            <span className="family-tree-legend-text">
                <span style={{ fontWeight: "bold" }}>Total {inLawLabel}</span> <span style={{ fontWeight: 900, fontSize: '16px' }}>({totalInLaws})</span>
            </span>
            <span style={{ margin: "0 12px" }}>|</span>
            <span className="family-tree-legend-text">
                <span style={{ fontWeight: "bold" }}>Grand Total</span> <span style={{ fontWeight: 900, fontSize: '16px' }}>({grandTotal})</span>
            </span>
          </div>
        </div>
        );
      })()}

      {/* Multiple Birth Sets breakdown modal */}
      {showMultipleBirthModal && multipleBirthBreakdown && (
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="multiple-birth-modal-title"
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0,0,0,0.35)",
          }}
          onClick={() => setShowMultipleBirthModal(false)}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "8px",
              padding: "24px",
              minWidth: "320px",
              maxWidth: "90vw",
              boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
              <h2 id="multiple-birth-modal-title" style={{ margin: 0, fontSize: "22px", fontWeight: "bold" }}>
                Multiple Birth Sets
              </h2>
              <button
                type="button"
                onClick={() => setShowMultipleBirthModal(false)}
                aria-label="Close"
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "26px",
                  cursor: "pointer",
                  lineHeight: 1,
                  color: "#666",
                }}
              >
                &times;
              </button>
            </div>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {[
                { key: "twins", label: "Twin(s)", count: multipleBirthBreakdown.twins },
                { key: "triplets", label: "Triplet(s)", count: multipleBirthBreakdown.triplets },
                { key: "quads", label: "Quad(s)", count: multipleBirthBreakdown.quads },
                { key: "quins", label: "Quin(s)", count: multipleBirthBreakdown.quins },
                { key: "sexs", label: "Sex(s)", count: multipleBirthBreakdown.sexs },
                { key: "seps", label: "Sep(s)", count: multipleBirthBreakdown.seps },
                { key: "ocs", label: "Oc(s)", count: multipleBirthBreakdown.ocs },
                { key: "nuns", label: "Non(s)", count: multipleBirthBreakdown.nuns },
              ]
                .filter(({ count }) => count > 0)
                .map(({ key, label, count }) => (
                  <li
                    key={key}
                    style={{
                      padding: "0",
                      lineHeight: 1,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontWeight: 500 }}>{label}</span>
                    <span style={{ fontWeight: 700, fontSize: "18px" }}>({count})</span>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      )}

      <RootHeadModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          // Only clear parent if NOT transitioning to next modal
          if (!isTransitioningRef.current) {
            setSelectedParentMember(null);
          }
          // Reset transition flag
          isTransitioningRef.current = false;
        }}
        onNext={(data) => {

          setRootHeadData(data); // Store the root head data
          // Set transition flag to prevent clearing parent
          isTransitioningRef.current = true;
          setIsModalOpen(false);
          setIsAddMemberModalOpen(true);
        }}
        rootHeadData={rootHeadData}
        parentMember={selectedParentMember} // Pass parent member to show appropriate text
        familyTreeId={getFamilyTreeIdFromStorage()} // Pass family tree ID
        allUsedColorsFromTree={allUsedColors} // Pass all used colors directly from tree data
      />

      <AddMemberModal
        isOpen={isAddMemberModalOpen}
        onClose={() => {
          setIsAddMemberModalOpen(false);
          setSelectedParentMember(null); // Clear parent when closing
          setEditMode(false); // Reset edit mode
          setEditMemberData(null); // Clear edit data
          returnToReportAfterEdit();
        }}
        onNext={async (responseData) => {


          // Close modal immediately for better UX
          setIsAddMemberModalOpen(false);
          setSelectedParentMember(null);
          setEditMode(false);
          setEditMemberData(null);

          // Opened from a report: the report reloads the saved record itself.
          if (returnToReportAfterEdit()) return;

          // Force re-render to show loading state immediately
          setTreeKey(Date.now());

          try {
            // Always refresh the tree after successful operation

            await fetchFamilyTreeData();

          } catch (error) {
            console.error("Error refreshing family tree:", error);
            toast.error(
              "Data updated but failed to refresh display. Please refresh the page."
            );
          }
        }}
        rootHeadData={rootHeadData} // Pass the root head data
        parentMember={selectedParentMember} // Pass parent member if adding child
        familyTreeId={familyTreeId} // Pass family tree ID
        isEditMode={editMode} // Pass edit mode flag
        editMemberData={editMemberData} // Pass member data for editing
      />

      <ViewMemberModal
        isOpen={isViewMemberModalOpen}
        onClose={() => setIsViewMemberModalOpen(false)}
        treeData={familyTreeData}
        memberData={viewMemberData || {}}
        setMemberData={setViewMemberData}
        onEdit={handleEdit}
        isRootGeneration={!viewMemberData?.parentId} // Check if it's root generation
        primaryLabel={
          !viewMemberData?.parentId
            ? "Grandfather"
            : viewMemberData?.generation === 1
              ? "Son"
              : viewMemberData?.generation === 2
                ? "Grandson"
                : viewMemberData?.generation === 3
                  ? "Great-Grandson"
                  : "Member"
        }
        spouseLabel={
          !viewMemberData?.parentId
            ? "Grandmother"
            : viewMemberData?.generation === 1
              ? "Daughter"
              : viewMemberData?.generation === 2
                ? "Granddaughter"
                : viewMemberData?.generation === 3
                  ? "Great-Granddaughter"
                  : "Spouse"
        }
      />

      {showInviteMemberModal && (
        <InviteMemberModal
          isOpen={showInviteMemberModal}
          onClose={() => setShowInviteMemberModal(false)}
          onInvite={(ids) => {

            setShowInviteMemberModal(false);
            handleProceedToImport(ids);
          }}
        />
      )}



      {showAddMemberPopup && (
        <AddMemberPopup
          selectedPerson={selectedHead}
          onClose={() => setShowAddMemberPopup(false)}
          onNext={() => setShowAddMemberPopup(false)}
        />
      )}

      {showAddFamilyPopup && (
        <AddFamilyMemberPopup
          onClose={() => setShowAddFamilyPopup(false)}
          onNext={(data) => {

            setShowAddFamilyPopup(false);
          }}
        />
      )}

      {/* // inside JSX (near other popups) */}
      {showImportPopup && (
        
        <ImportDataModal
          isOpen={showImportPopup}
          onClose={() => {
            setShowImportPopup(false);
            setImportTreeSide("");
            setImportTreeSideSelectionLocked(false);
            setImportTreeSideVisibleSides("both");
          }}
          data={""}
          treeSide={importTreeSide}
          onTreeSideChange={setImportTreeSide}
          selectionLocked={importTreeSideSelectionLocked}
          visibleSides={importTreeSideVisibleSides}
          onImport={(data) => {
            handleImportedData(data);
          }}
        />
      )}

      {importErrorModalOpen && (
        <ImportErrorModal
          isOpen={importErrorModalOpen}
          onClose={() => setImportErrorModalOpen(false)}
          serverError={importErrorMessage}
          title="Import Errors"
          helpNote="Fix the listed issues and try again."
        />
      )}

      {showReorderModal && reorderModalData && (
        <ReorderMultipleBirthModal
          isOpen={showReorderModal}
          onClose={handleReorderModalClose}
          members={reorderModalData.members}
          birthType={reorderModalData.birthType}
          setNumber={reorderModalData.setNumber}
        />
      )}

      {openProceedToImportModal && (
        <ImportDataModal
          isOpen={openProceedToImportModal}
          onClose={() => {
            setOpenProceedToImportModal(false);
            setImportTreeSide("");
            setImportTreeSideSelectionLocked(false);
            setImportTreeSideVisibleSides("both");
          }}
          data={selectedIdForImport}
          treeSide={importTreeSide}
          onTreeSideChange={setImportTreeSide}
          selectionLocked={importTreeSideSelectionLocked}
          visibleSides={importTreeSideVisibleSides}
          onImport={(data) => {
            handleImportedData(data);
          }}
        />
      )}
    </div>
  );
}

export default FamilyTree;
